(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpe-3f-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.a3fReady === 'true') return;
      root.dataset.a3fReady = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.classList.add('a3f--motion-ready');
      const title = root.querySelector('[data-a3f-title]');
      if (title && !title.dataset.a3fSplit) {
        const words = title.textContent.trim().split(/\s+/);
        title.setAttribute('aria-label', title.textContent.trim());
        title.textContent = '';
        words.forEach((word, index) => {
          const span = document.createElement('span');
          span.className = 'a3f__word';
          span.setAttribute('aria-hidden', 'true');
          span.style.transitionDelay = `${index * 55}ms`;
          span.textContent = word;
          title.append(span, document.createTextNode(' '));
        });
        title.dataset.a3fSplit = 'true';
        requestAnimationFrame(() => title.classList.add('a3f__title-visible'));
      }
      const revealItems = root.querySelectorAll('[data-a3f-reveal]');
      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('a3f__is-visible'));
      } else {
        const revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('a3f__is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' });
        revealItems.forEach((item) => revealObserver.observe(item));
      }
      const storySteps = root.querySelectorAll('[data-a3f-story-step]');
      if ('IntersectionObserver' in window) {
        const storyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.target.classList.toggle('a3f__step-active', entry.isIntersecting));
        }, { threshold: 0.7 });
        storySteps.forEach((step) => storyObserver.observe(step));
      }
      if (!reduceMotion && window.matchMedia('(pointer:fine)').matches) {
        root.querySelector('.a3f__hero')?.addEventListener('pointermove', (event) => {
          const bounds = event.currentTarget.getBoundingClientRect();
          root.style.setProperty('--a3f-x', ((event.clientX - bounds.left) / bounds.width - 0.5).toFixed(3));
          root.style.setProperty('--a3f-y', ((event.clientY - bounds.top) / bounds.height - 0.5).toFixed(3));
        });
      }
      const dialog = root.querySelector('[data-a3f-size-dialog]');
      root.querySelectorAll('[data-a3f-open-size]').forEach((button) => button.addEventListener('click', () => dialog?.showModal()));
      root.querySelector('[data-a3f-close-size]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      const variantId = root.querySelector('[data-a3f-variant-id]');
      const price = root.querySelector('[data-a3f-price]');
      const mobilePrice = root.querySelector('[data-a3f-mobile-price]');
      root.querySelectorAll('.a3f__size-input').forEach((input) => input.addEventListener('change', () => {
        variantId.value = input.value;
        price.textContent = input.dataset.price;
        if (mobilePrice) mobilePrice.textContent = input.dataset.price;
      }));
    };
    document.querySelectorAll('[data-alpe-3-f], [data-alpe-3f]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-alpe-3f]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpe-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  class AlpeBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.root = this.dataset.root || '/';
      this.currency = this.dataset.currency || 'EUR';
      this.bundleName = this.dataset.bundleName || 'Alpe komplet';
      this.discountPercent = Number(this.dataset.discountPercent || 0);
      this.discountCode = this.dataset.discountCode || '';
      this.afterAdd = this.dataset.afterAdd || 'drawer';
      this.completeLabel = this.dataset.completeLabel || 'Dodaj komplet v košarico';
      this.incompleteLabel = this.dataset.incompleteLabel || 'Dopolni komplet';
      this.statusNode = this.querySelector('[data-alpe-status]');
      this.stageStatusNode = this.querySelector('[data-alpe-stage-status]');
      this.summarySlotsNode = this.querySelector('[data-alpe-summary-slots]');
      this.emptyStageNode = this.querySelector('[data-alpe-empty-stage]');
      this.submitButtons = Array.from(this.querySelectorAll('[data-alpe-submit]'));
      this.cardNodes = new Map();
      this.productState = new Map();
      this.selections = {};
      this.loading = false;

      const data = this.readData();
      this.stages = data.stages || [];
      this.products = data.products || [];
      this.activeStageKey = this.stages[0] ? this.stages[0].key : '';

      this.style.setProperty('--alpe-stage-count', Math.max(this.stages.length, 1));
      this.indexCards();
      this.bindTabs();
      this.bindCards();
      this.bindSubmit();
      this.render();
    }

    readData() {
      const node = this.querySelector('[data-alpe-bundle-data]');
      if (!node) return { stages: [], products: [] };
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        this.setStatus('Konfiguracija kompleta ni pravilno naložena.');
        return { stages: [], products: [] };
      }
    }

    indexCards() {
      this.querySelectorAll('[data-alpe-product-card]').forEach((card) => {
        this.cardNodes.set(card.dataset.alpeProductCard, card);
      });
    }

    bindTabs() {
      this.querySelectorAll('[data-alpe-stage-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activeStageKey = tab.dataset.stageKey;
          this.render();
          this.scrollToStage(tab.dataset.stageKey);
        });
      });
    }

    bindCards() {
      this.products.forEach((item) => {
        const card = this.cardNodes.get(item.blockId);
        if (!card) return;
        const state = {
          selectedOptions: {},
          variant: this.getInitialVariant(item.product)
        };
        this.productState.set(item.blockId, state);
        this.renderOptions(item, card);

        const button = card.querySelector('[data-alpe-product-submit]');
        if (button) {
          button.addEventListener('click', () => this.selectProduct(item));
        }
      });
    }

    bindSubmit() {
      this.submitButtons.forEach((button) => {
        button.addEventListener('click', () => this.handleSubmit());
      });
    }

    render() {
      this.renderTabs();
      this.renderCards();
      this.renderSummary();
      this.renderStageStatus();
    }

    renderTabs() {
      this.querySelectorAll('[data-alpe-stage-tab]').forEach((tab) => {
        const key = tab.dataset.stageKey;
        const isActive = key === this.activeStageKey;
        const isComplete = Boolean(this.selections[key]);
        tab.classList.toggle('is-active', isActive);
        tab.classList.toggle('is-complete', isComplete);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    renderCards() {
      this.products.forEach((item) => {
        const card = this.cardNodes.get(item.blockId);
        if (!card) return;
        this.updateCard(item, card);
      });
    }

    renderOptions(item, card) {
      const optionsRoot = card.querySelector('[data-alpe-options]');
      if (!optionsRoot) return;
      optionsRoot.innerHTML = '';

      const optionList = this.getVisibleOptions(item.product);
      if (optionList.length === 0) return;

      optionList.forEach((option) => {
        const group = document.createElement('div');
        group.className = 'alpe-bundle__option-group';

        const label = document.createElement('div');
        label.className = 'alpe-bundle__option-label';
        label.textContent = option.name;

        const values = document.createElement('div');
        values.className = 'alpe-bundle__option-values';

        option.values.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'alpe-bundle__option-button';
          button.textContent = value;
          button.dataset.optionIndex = option.index;
          button.dataset.optionValue = value;
          button.addEventListener('click', () => {
            const state = this.productState.get(item.blockId);
            state.selectedOptions[option.index] = value;
            state.variant = this.findSelectedVariant(item, state);
            this.renderOptions(item, card);
            this.updateCard(item, card);
          });
          values.appendChild(button);
        });

        group.appendChild(label);
        group.appendChild(values);
        optionsRoot.appendChild(group);
      });

      this.updateOptionButtons(item, card);
    }

    updateOptionButtons(item, card) {
      const state = this.productState.get(item.blockId);
      if (!state) return;

      card.querySelectorAll('[data-option-index]').forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const value = button.dataset.optionValue;
        const selected = state.selectedOptions[optionIndex] === value;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.disabled = !this.isOptionValueAvailable(item, optionIndex, value, state);
      });
    }

    updateCard(item, card) {
      const state = this.productState.get(item.blockId);
      const selection = this.selections[item.stageKey];
      const isSelected = selection && selection.blockId === item.blockId;
      const variant = state ? state.variant : null;
      const priceNode = card.querySelector('[data-alpe-card-price]');
      const cta = card.querySelector('[data-alpe-product-submit]');
      const status = card.querySelector('[data-alpe-card-status]');

      card.classList.toggle('is-selected', Boolean(isSelected));
      this.updateOptionButtons(item, card);

      if (priceNode) {
        const price = variant ? variant.price : item.product.price;
        const compareAt = variant ? variant.compareAtPrice : item.product.compareAtPrice;
        priceNode.innerHTML = `${compareAt && compareAt > price ? `<s>${this.formatMoney(compareAt)}</s>` : ''}<span>${this.formatMoney(price)}</span>`;
      }

      if (cta) {
        const needsOptions = this.needsOptions(item.product);
        const available = item.product.available && (!variant || variant.available);
        cta.disabled = !item.product.available;
        if (!item.product.available) {
          cta.textContent = 'Razprodano';
        } else if (isSelected) {
          cta.textContent = 'Dodano v komplet';
        } else if (needsOptions && !variant) {
          cta.textContent = 'Izberi velikost';
        } else {
          cta.textContent = 'Dodaj izdelek v komplet';
        }
        if (!available) cta.disabled = true;
      }

      if (status) {
        status.textContent = '';
      }
    }

    renderSummary() {
      if (this.summarySlotsNode) {
        this.summarySlotsNode.innerHTML = '';
        this.stages.forEach((stage) => {
          const selected = this.selections[stage.key];
          const slot = document.createElement('div');
          slot.className = `alpe-bundle__slot${selected ? ' is-filled' : ''}`;

          const box = document.createElement('button');
          box.type = 'button';
          box.className = 'alpe-bundle__slot-box';
          box.setAttribute('aria-label', selected ? `${stage.title}: ${selected.title}` : `${stage.title}: izberi izdelek`);
          box.addEventListener('click', () => {
            this.activeStageKey = stage.key;
            this.render();
            this.scrollToStage(stage.key);
          });

          if (selected && selected.image) {
            const image = document.createElement('img');
            image.className = 'alpe-bundle__slot-image';
            image.src = selected.image;
            image.alt = selected.title;
            box.appendChild(image);

            const remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'alpe-bundle__slot-remove';
            remove.setAttribute('aria-label', `Odstrani ${stage.title}`);
            remove.textContent = '×';
            remove.addEventListener('click', (event) => {
              event.stopPropagation();
              delete this.selections[stage.key];
              this.activeStageKey = stage.key;
              this.render();
            });
            box.appendChild(remove);
          } else {
            const plus = document.createElement('span');
            plus.className = 'alpe-bundle__slot-plus';
            plus.textContent = '+';
            box.appendChild(plus);
          }

          const label = document.createElement('span');
          label.className = 'alpe-bundle__slot-label';
          label.textContent = stage.title;

          slot.appendChild(box);
          slot.appendChild(label);
          this.summarySlotsNode.appendChild(slot);
        });
      }

      const selectedItems = this.getSelectedItems();
      const subtotal = selectedItems.reduce((sum, item) => sum + Number(item.variant.price || 0), 0);
      const complete = this.isComplete();
      const discount = complete && this.discountPercent > 0 ? Math.round(subtotal * this.discountPercent / 100) : 0;
      const total = Math.max(subtotal - discount, 0);
      const subtotalNode = this.querySelector('[data-alpe-summary-subtotal]');

      this.setHtml('[data-alpe-summary-total]', this.formatMoney(total));
      if (subtotalNode) {
        subtotalNode.hidden = !(complete && discount > 0);
        subtotalNode.innerHTML = this.formatMoney(subtotal);
      }

      this.submitButtons.forEach((button) => {
        button.disabled = this.loading || this.stages.length === 0;
        button.textContent = this.loading ? 'Dodajam...' : complete ? this.completeLabel : this.incompleteLabel;
      });

      if (!complete && this.statusNode && !this.statusNode.textContent.trim()) {
        this.statusNode.textContent = this.incompleteLabel;
      }
    }

    renderStageStatus() {
      if (!this.stageStatusNode) return;
      const current = this.stages.find((stage) => stage.key === this.activeStageKey);
      if (!current) {
        this.stageStatusNode.textContent = '';
        return;
      }
      this.stageStatusNode.textContent = this.selections[current.key]
        ? `${current.title} je izbran. Nadaljuj na naslednji korak ali zamenjaj izbiro.`
        : `Izberi izdelek za kategorijo: ${current.title}.`;
    }

    selectProduct(item) {
      const state = this.productState.get(item.blockId);
      const variant = state ? state.variant : this.getInitialVariant(item.product);
      if (!item.product.available) return;
      if (this.needsOptions(item.product) && !variant) {
        this.setCardStatus(item.blockId, 'Najprej izberi velikost.');
        return;
      }
      if (!variant || !variant.available) {
        this.setCardStatus(item.blockId, 'Ta izbira trenutno ni na voljo.');
        return;
      }

      this.selections[item.stageKey] = {
        blockId: item.blockId,
        stageKey: item.stageKey,
        productId: item.product.id,
        variant,
        title: item.displayTitle || item.product.title,
        image: variant.featuredImage || item.product.featuredImage,
        productUrl: item.product.url
      };

      const next = this.getNextIncompleteStage(item.stageKey);
      if (next) {
        this.activeStageKey = next.key;
      }
      this.setStatus('');
      this.render();
      if (next) this.scrollToStage(next.key);
    }

    async handleSubmit() {
      if (!this.isComplete()) {
        this.promptIncomplete();
        return;
      }
      await this.addToCart();
    }

    promptIncomplete() {
      const missing = this.getMissingStages();
      if (!missing.length) return;
      this.activeStageKey = missing[0].key;
      this.setStatus(this.incompleteLabel);
      this.render();
      this.scrollToStage(missing[0].key);
    }

    async addToCart() {
      const selected = this.getSelectedItems();
      if (!selected.length || this.loading) return;

      this.loading = true;
      this.renderSummary();

      const bundleId = `alpe-${Date.now()}`;
      const payload = {
        items: selected.map((item) => ({
          id: item.variant.id,
          quantity: 1,
          properties: {
            '_alpe_bundle_id': bundleId,
            '_alpe_bundle_discount_code': this.discountCode || '',
            'Komplet': this.bundleName,
            'Kategorija': this.getStageTitle(item.stageKey)
          }
        }))
      };

      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok) throw data;

        if (this.discountCode.trim()) {
          await this.applyDiscountCode();
        }

        const cart = await this.fetchCart();
        this.updateCartCount(cart);
        document.dispatchEvent(new CustomEvent('alpe:bundle:add', { detail: { response: data, cart, bundleId } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { response: data, cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));

        if (this.afterAdd === 'cart') {
          this.goToCart();
          return;
        }
        this.setStatus('Komplet je dodan v košarico.');
      } catch (error) {
        this.setStatus('Kompleta ni bilo mogoče dodati. Preveri izbire in poskusi znova.');
      } finally {
        this.loading = false;
        this.renderSummary();
      }
    }

    async applyDiscountCode() {
      const code = this.discountCode.trim();
      if (!code) return false;
      try {
        const response = await fetch(`${this.root}discount/${encodeURIComponent(code)}`, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        return response.ok;
      } catch (error) {
        return false;
      }
    }

    goToCart() {
      const code = this.discountCode.trim();
      if (code) {
        window.location.href = `${this.root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${this.root}cart`)}`;
        return;
      }
      window.location.href = `${this.root}cart`;
    }

    async fetchCart() {
      try {
        const response = await fetch(`${this.root}cart.js`, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
        });
        return await response.json();
      } catch (error) {
        return null;
      }
    }

    getVisibleOptions(product) {
      return (product.options || [])
        .map((option, index) => ({ ...option, index }))
        .filter((option) => option.name && option.name !== 'Title' && option.values.some((value) => value !== 'Default Title'));
    }

    needsOptions(product) {
      return this.getVisibleOptions(product).length > 0;
    }

    getInitialVariant(product) {
      const variants = product.variants || [];
      const available = variants.find((variant) => variant.available);
      if (!available) return null;
      return this.needsOptions(product) ? null : available;
    }

    findSelectedVariant(item, state) {
      const visibleOptions = this.getVisibleOptions(item.product);
      if (visibleOptions.some((option) => !state.selectedOptions[option.index])) return null;
      return (item.product.variants || []).find((variant) => {
        if (!variant.available) return false;
        return visibleOptions.every((option) => variant.options[option.index] === state.selectedOptions[option.index]);
      }) || null;
    }

    isOptionValueAvailable(item, optionIndex, value, state) {
      const selected = { ...(state ? state.selectedOptions : {}), [optionIndex]: value };
      return (item.product.variants || []).some((variant) => {
        if (!variant.available) return false;
        return Object.entries(selected).every(([index, selectedValue]) => variant.options[Number(index)] === selectedValue);
      });
    }

    getSelectedItems() {
      return this.stages
        .map((stage) => this.selections[stage.key])
        .filter(Boolean);
    }

    getMissingStages() {
      return this.stages.filter((stage) => !this.selections[stage.key]);
    }

    isComplete() {
      return this.stages.length > 0 && this.getMissingStages().length === 0;
    }

    getNextIncompleteStage(currentKey) {
      const currentIndex = this.stages.findIndex((stage) => stage.key === currentKey);
      const afterCurrent = this.stages.slice(currentIndex + 1).find((stage) => !this.selections[stage.key]);
      if (afterCurrent) return afterCurrent;
      return this.stages.find((stage) => !this.selections[stage.key]) || null;
    }

    getStageTitle(stageKey) {
      const stage = this.stages.find((item) => item.key === stageKey);
      return stage ? stage.title : stageKey;
    }

    setCardStatus(blockId, text) {
      const card = this.cardNodes.get(blockId);
      const status = card ? card.querySelector('[data-alpe-card-status]') : null;
      if (status) status.textContent = text;
    }

    setStatus(text) {
      if (this.statusNode) this.statusNode.textContent = text;
    }

    setText(selector, text) {
      this.querySelectorAll(selector).forEach((node) => {
        node.textContent = text;
      });
    }

    setHtml(selector, html) {
      this.querySelectorAll(selector).forEach((node) => {
        node.innerHTML = html;
      });
    }

    scrollToStage(stageKey) {
      const target = Array.from(this.querySelectorAll('[data-alpe-stage-section]'))
        .find((section) => section.dataset.stageKey === stageKey);
      if (!target) return;
      const offset = window.matchMedia('(max-width: 760px)').matches ? 92 : 128;
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    updateCartCount(cart) {
      if (!cart) return;
      document.querySelectorAll('.cart-link__bubble').forEach((bubble) => {
        bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      });
      document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
      });
    }

    formatMoney(cents) {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(Number(cents || 0), theme.settings.moneyFormat);
      }
      return `${(Number(cents || 0) / 100).toFixed(2)} ${this.currency}`;
    }
  }

  if (!customElements.get('alpe-bundle-builder')) {
    customElements.define('alpe-bundle-builder', AlpeBundleBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpe-tour-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  class AlpeTourBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.root = this.dataset.root || '/';
      this.currency = this.dataset.currency || 'EUR';
      this.bundleName = this.dataset.bundleName || 'Alpe komplet';
      this.useRegularPrices = this.dataset.useRegularPrices === 'true';
      this.discountPercent = Number(this.dataset.discountPercent || 0);
      this.discountCode = this.dataset.discountCode || '';
      this.afterAdd = this.dataset.afterAdd || 'drawer';
      this.completeLabel = this.dataset.completeLabel || 'Dodaj komplet v košarico';
      this.incompleteLabel = this.dataset.incompleteLabel || 'Dopolni komplet';
      this.addedLabel = 'Komplet je v košarici';
      this.statusNode = this.querySelector('[data-alpe-status]');
      this.stageStatusNode = this.querySelector('[data-alpe-stage-status]');
      this.summarySlotsNode = this.querySelector('[data-alpe-summary-slots]');
      this.summaryBadgeNode = this.querySelector('[data-alpe-summary-badge]');
      this.summaryDiscountPercentNode = this.querySelector('[data-alpe-summary-discount-percent]');
      this.summaryNode = this.querySelector('[data-alpe-summary]');
      this.summaryProgressNode = this.querySelector('[data-alpe-summary-progress]');
      this.summaryToggle = this.querySelector('[data-alpe-summary-toggle]');
      this.removeIconTemplate = this.querySelector('[data-alpe-remove-icon]');
      this.plusIconTemplate = this.querySelector('[data-alpe-plus-icon]');
      this.emptyStageNode = this.querySelector('[data-alpe-empty-stage]');
      this.submitButtons = Array.from(this.querySelectorAll('[data-alpe-submit]'));
      this.cardNodes = new Map();
      this.productState = new Map();
      this.selections = {};
      this.activeFilters = new Map();
      this.loading = false;
      this.addedToCart = false;
      this.lastAddedBundleId = '';
      this.cartSyncToken = 0;
      this.scrollAnimationFrame = null;
      this.summaryCollapsed = false;

      const data = this.readData();
      this.stages = data.stages || [];
      this.products = data.products || [];
      this.activeStageKey = this.stages[0] ? this.stages[0].key : '';
      this.storageKey = `alpeTourBundle:v2:${window.location.pathname}:${this.id || 'default'}`;

      this.handlePageShow = () => this.syncCartState();
      this.handleVisibilityChange = () => {
        if (!document.hidden) this.syncCartState();
      };
      this.handleCartUpdated = (event) => this.syncCartState(event.detail && event.detail.cart);

      this.style.setProperty('--alpe-stage-count', Math.max(this.stages.length, 1));
      this.indexCards();
      this.bindTabs();
      this.bindFilters();
      this.bindCards();
      this.restoreSelections();
      this.bindSubmit();
      this.bindSummaryToggle();
      this.bindSummarySlots();
      window.addEventListener('pageshow', this.handlePageShow);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      document.addEventListener('cart:updated', this.handleCartUpdated);
      this.render();
      this.syncCartState();
    }

    disconnectedCallback() {
      if (this.scrollAnimationFrame) window.cancelAnimationFrame(this.scrollAnimationFrame);
      window.removeEventListener('pageshow', this.handlePageShow);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      document.removeEventListener('cart:updated', this.handleCartUpdated);
    }

    updateSummaryVisibility() {
      if (!this.summaryNode) return;
      const hasSelection = this.getSelectedItems().length > 0;
      this.summaryNode.classList.toggle('is-visible', hasSelection);
    }

    readData() {
      const node = this.querySelector('[data-alpe-bundle-data]');
      if (!node) return { stages: [], products: [] };
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        this.setStatus('Konfiguracija kompleta ni pravilno naložena.');
        return { stages: [], products: [] };
      }
    }

    indexCards() {
      this.querySelectorAll('[data-alpe-product-card]').forEach((card) => {
        this.cardNodes.set(card.dataset.alpeProductCard, card);
      });
    }

    bindTabs() {
      this.querySelectorAll('[data-alpe-stage-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activeStageKey = tab.dataset.stageKey;
          this.render();
          this.scrollToStage(tab.dataset.stageKey);
        });
      });
    }

    bindCards() {
      this.products.forEach((item) => {
        const card = this.cardNodes.get(item.blockId);
        if (!card) return;
        const initialVariant = this.getInitialVariant(item.product);
        const selectedOptions = {};
        if (initialVariant) {
          this.getVisibleOptions(item.product).forEach((option) => {
            selectedOptions[option.index] = initialVariant.options[option.index];
          });
        }
        const state = {
          selectedOptions,
          variant: initialVariant
        };
        this.productState.set(item.blockId, state);
        this.renderOptions(item, card);

        const button = card.querySelector('[data-alpe-product-submit]');
        if (button) {
          button.addEventListener('click', () => this.selectProduct(item));
        }
      });
    }

    bindFilters() {
      this.querySelectorAll('[data-alpe-filter]').forEach((button) => {
        const stageKey = button.dataset.stageKey;
        const tag = button.dataset.filterTag;
        const group = button.dataset.filterGroup || tag;
        if (button.getAttribute('aria-pressed') === 'true') {
          if (!this.activeFilters.has(stageKey)) this.activeFilters.set(stageKey, new Map());
          this.activeFilters.get(stageKey).set(group, tag);
        }
        button.addEventListener('click', () => {
          if (!this.activeFilters.has(stageKey)) this.activeFilters.set(stageKey, new Map());
          const stageFilters = this.activeFilters.get(stageKey);
          if (stageFilters.get(group) === tag) {
            stageFilters.delete(group);
          } else {
            stageFilters.set(group, tag);
          }
          this.render();
        });
      });
    }

    bindSubmit() {
      this.submitButtons.forEach((button) => {
        button.addEventListener('click', () => this.handleSubmit());
      });
    }

    bindSummaryToggle() {
      if (!this.summaryToggle || !this.summaryNode) return;
      this.summaryToggle.addEventListener('click', () => {
        this.summaryCollapsed = !this.summaryCollapsed;
        this.renderSummaryState();
      });
    }

    bindSummarySlots() {
      if (!this.summarySlotsNode || this.summarySlotsBound) return;
      this.summarySlotsBound = true;
      this.summarySlotsNode.addEventListener('click', (event) => {
        const slot = event.target instanceof Element
          ? event.target.closest('.alpe-bundle__slot')
          : null;
        if (!slot || !this.summarySlotsNode.contains(slot)) return;
        if (event.target.closest('.alpe-bundle__slot-remove')) return;

        const stageKey = slot.dataset.stageKey;
        if (!stageKey) return;

        this.activeStageKey = stageKey;
        this.setStatus('');
        this.render();
        this.scrollToStage(stageKey);
      });
    }

    renderSummaryState() {
      if (!this.summaryNode) return;
      this.summaryNode.classList.toggle('is-collapsed', this.summaryCollapsed);
      if (this.summaryToggle) {
        this.summaryToggle.setAttribute('aria-expanded', this.summaryCollapsed ? 'false' : 'true');
        this.summaryToggle.setAttribute('aria-label', this.summaryCollapsed ? 'Odpri povzetek kompleta' : 'Zapri povzetek kompleta');
      }
    }

    render() {
      this.renderTabs();
      this.renderFilters();
      this.renderCards();
      this.renderSummary();
      this.renderStageStatus();
      this.persistSelections();
    }

    renderTabs() {
      this.querySelectorAll('[data-alpe-stage-tab]').forEach((tab) => {
        const key = tab.dataset.stageKey;
        const isActive = key === this.activeStageKey;
        const isComplete = Boolean(this.selections[key]);
        tab.classList.toggle('is-active', isActive);
        tab.classList.toggle('is-complete', isComplete);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.querySelectorAll('[data-alpe-stage-section]').forEach((section) => {
        section.hidden = section.dataset.stageKey !== this.activeStageKey;
      });
    }

    renderFilters() {
      this.querySelectorAll('[data-alpe-filter]').forEach((button) => {
        const stageFilters = this.activeFilters.get(button.dataset.stageKey);
        const group = button.dataset.filterGroup || button.dataset.filterTag;
        const active = Boolean(stageFilters && stageFilters.get(group) === button.dataset.filterTag);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    renderCards() {
      const visibleByStage = new Map();
      this.products.forEach((item) => {
        const card = this.cardNodes.get(item.blockId);
        if (!card) return;
        const visible = this.productMatchesFilters(item);
        card.hidden = !visible;
        if (visible) visibleByStage.set(item.stageKey, (visibleByStage.get(item.stageKey) || 0) + 1);
        this.updateCard(item, card);
      });
      this.querySelectorAll('[data-alpe-filter-empty]').forEach((node) => {
        const stage = node.closest('[data-alpe-stage-section]');
        node.hidden = !stage || (visibleByStage.get(stage.dataset.stageKey) || 0) > 0;
      });
    }

    productMatchesFilters(item) {
      const tags = (item.product.tags || []).map((tag) => String(tag).trim().toLowerCase());
      const relevantFilters = ['all', item.stageKey]
        .map((key) => this.activeFilters.get(key))
        .filter(Boolean)
        .flatMap((filters) => Array.from(filters.values()));
      if (relevantFilters.length === 0) return true;
      return relevantFilters.every((tag) => tags.includes(String(tag).trim().toLowerCase()));
    }

    renderOptions(item, card) {
      const optionsRoot = card.querySelector('[data-alpe-options]');
      if (!optionsRoot) return;
      optionsRoot.innerHTML = '';

      const optionList = this.getVisibleOptions(item.product);
      if (optionList.length === 0) return;

      optionList.forEach((option) => {
        const group = document.createElement('div');
        group.className = 'alpe-bundle__option-group';

        const label = document.createElement('div');
        label.className = 'alpe-bundle__option-label';
        label.textContent = option.name;

        const values = document.createElement('div');
        values.className = 'alpe-bundle__option-values';

        option.values.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'alpe-bundle__option-button';
          button.textContent = value;
          button.dataset.optionIndex = option.index;
          button.dataset.optionValue = value;
          button.addEventListener('click', () => {
            const state = this.productState.get(item.blockId);
            state.selectedOptions[option.index] = value;
            state.variant = this.findSelectedVariant(item, state);
            this.resetAddedState();
            this.renderOptions(item, card);
            this.updateCard(item, card);
          });
          values.appendChild(button);
        });

        group.appendChild(label);
        group.appendChild(values);
        optionsRoot.appendChild(group);
      });

      this.updateOptionButtons(item, card);
    }

    updateOptionButtons(item, card) {
      const state = this.productState.get(item.blockId);
      if (!state) return;

      card.querySelectorAll('[data-option-index]').forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const value = button.dataset.optionValue;
        const selected = state.selectedOptions[optionIndex] === value;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.disabled = !this.isOptionValueAvailable(item, optionIndex, value, state);
      });
    }

    updateCard(item, card) {
      const state = this.productState.get(item.blockId);
      const selection = this.selections[item.stageKey];
      const isSelected = selection && selection.blockId === item.blockId;
      const variant = state ? state.variant : null;
      const priceNode = card.querySelector('[data-alpe-card-price]');
      const cta = card.querySelector('[data-alpe-product-submit]');
      const status = card.querySelector('[data-alpe-card-status]');

      card.classList.toggle('is-selected', Boolean(isSelected));
      this.updateOptionButtons(item, card);

      if (priceNode) {
        const pricing = this.getPricing(variant || item.product);
        priceNode.innerHTML = `${pricing.compareAt ? `<s>${this.formatMoney(pricing.compareAt)}</s>` : ''}<span>${this.formatMoney(pricing.price)}</span>`;
      }

      if (cta) {
        const needsOptions = this.needsOptions(item.product);
        const available = item.product.available && (!variant || variant.available);
        cta.disabled = !item.product.available;
        if (!item.product.available) {
          cta.textContent = 'Razprodano';
        } else if (isSelected) {
          cta.textContent = 'Dodano v komplet';
        } else if (needsOptions && !variant) {
          cta.textContent = 'Izberi velikost';
        } else {
          cta.textContent = 'Dodaj izdelek v komplet';
        }
        if (!available) cta.disabled = true;
      }

      if (status) {
        status.textContent = '';
      }
    }

    renderSummary() {
      if (this.summarySlotsNode) {
        this.summarySlotsNode.innerHTML = '';
        this.stages.forEach((stage) => {
          const selected = this.selections[stage.key];
          const slot = document.createElement('div');
          slot.className = `alpe-bundle__slot${selected ? ' is-filled' : ''}`;
          slot.dataset.stageKey = stage.key;
          if (selected) slot.dataset.variantId = String(selected.variant.id);

          const box = document.createElement('button');
          box.type = 'button';
          box.className = 'alpe-bundle__slot-box';
          box.dataset.alpeSummaryStage = stage.key;
          box.setAttribute('aria-label', selected ? `${stage.title}: ${this.getSelectionLabel(selected)}` : `${stage.title}: izberi izdelek`);

          let remove = null;
          if (selected && selected.image) {
            const image = document.createElement('img');
            image.className = 'alpe-bundle__slot-image';
            image.src = selected.image;
            image.alt = selected.title;
            box.appendChild(image);

            remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'alpe-bundle__slot-remove';
            remove.setAttribute('aria-label', `Odstrani ${stage.title}`);
            if (this.removeIconTemplate) remove.appendChild(this.removeIconTemplate.content.cloneNode(true));
            remove.addEventListener('click', (event) => {
              event.stopPropagation();
              delete this.selections[stage.key];
              this.activeStageKey = stage.key;
              this.resetAddedState();
              this.render();
            });
          } else {
            const plus = document.createElement('span');
            plus.className = 'alpe-bundle__slot-plus';
            if (this.plusIconTemplate) plus.appendChild(this.plusIconTemplate.content.cloneNode(true));
            box.appendChild(plus);
          }

          const label = document.createElement('span');
          label.className = 'alpe-bundle__slot-label';
          label.textContent = selected ? this.getSelectionLabel(selected) : stage.title;

          if (selected) {
            const pricing = this.getBundlePricing(selected.variant);
            const price = document.createElement('span');
            price.className = 'alpe-bundle__slot-price';
            if (pricing.compareAt) {
              const compareAt = document.createElement('s');
              compareAt.textContent = this.formatMoney(pricing.compareAt);
              price.appendChild(compareAt);
            }
            const amount = document.createElement('span');
            amount.textContent = this.formatMoney(pricing.price);
            price.appendChild(amount);
            slot.appendChild(price);
          }

          slot.appendChild(box);
          if (remove) slot.appendChild(remove);
          slot.appendChild(label);
          this.summarySlotsNode.appendChild(slot);
        });
      }

      const selectedItems = this.getSelectedItems();
      const subtotal = selectedItems.reduce((sum, item) => sum + this.getBundlePricing(item.variant).regular, 0);
      const total = selectedItems.reduce((sum, item) => sum + this.getBundlePricing(item.variant).price, 0);
      const complete = this.isComplete();
      const discount = Math.max(subtotal - total, 0);
      const subtotalNode = this.querySelector('[data-alpe-summary-subtotal]');
      const discountPercent = Math.max(0, Math.round(this.discountPercent || 0));

      this.updateSummaryVisibility();
      this.renderSummaryState();

      if (this.summaryProgressNode) {
        this.summaryProgressNode.textContent = `Sestavi svoj komplet (${selectedItems.length}/${this.stages.length})`;
      }

      this.setHtml('[data-alpe-summary-total]', this.formatMoney(total));
      if (subtotalNode) {
        subtotalNode.hidden = !(selectedItems.length > 0 && discount > 0);
        subtotalNode.innerHTML = this.formatMoney(subtotal);
      }
      if (this.summaryDiscountPercentNode) {
        this.summaryDiscountPercentNode.textContent = `${discountPercent} %`;
      }
      if (this.summaryBadgeNode) {
        this.summaryBadgeNode.hidden = !(selectedItems.length > 0 && discountPercent > 0);
        if (selectedItems.length > 0 && discountPercent > 0) {
          this.summaryBadgeNode.textContent = `-${discountPercent} %`;
          this.summaryBadgeNode.setAttribute('aria-label', `${discountPercent} % popusta`);
        }
      }

      this.submitButtons.forEach((button) => {
        const added = complete && this.addedToCart;
        button.disabled = this.loading || this.stages.length === 0 || added;
        button.classList.toggle('is-success', added);
        button.classList.toggle('is-incomplete', !complete);
        button.textContent = this.loading
          ? 'Dodajam...'
          : added
            ? this.addedLabel
            : complete
              ? this.completeLabel
              : this.incompleteLabel;
      });

      if (!complete && this.statusNode && this.statusNode.dataset.alpeStatusState === 'hint') {
        this.setStatus('');
      }
    }

    renderStageStatus() {
      if (!this.stageStatusNode) return;
      const current = this.stages.find((stage) => stage.key === this.activeStageKey);
      if (!current) {
        this.stageStatusNode.textContent = '';
        return;
      }
      this.stageStatusNode.textContent = this.selections[current.key]
        ? `${current.title} je izbran. Nadaljuj na naslednji korak ali zamenjaj izbiro.`
        : `Izberi izdelek za kategorijo: ${current.title}.`;
    }

    selectProduct(item) {
      const state = this.productState.get(item.blockId);
      const variant = state ? state.variant : this.getInitialVariant(item.product);
      if (!item.product.available) return;
      if (this.needsOptions(item.product) && !variant) {
        this.setCardStatus(item.blockId, 'Najprej izberi velikost.');
        return;
      }
      if (!variant || !variant.available) {
        this.setCardStatus(item.blockId, 'Ta izbira trenutno ni na voljo.');
        return;
      }

      this.resetAddedState();

      this.selections[item.stageKey] = this.createSelection(item, variant);

      const next = this.getNextIncompleteStage(item.stageKey);
      this.summaryCollapsed = false;
      if (next) {
        this.activeStageKey = next.key;
      }
      this.setStatus('');
      this.render();
      if (this.isComplete()) this.syncCartState();
      if (next) this.scrollToStage(next.key);
    }

    async handleSubmit() {
      if (!this.isComplete()) {
        this.promptIncomplete();
        return;
      }
      await this.addToCart();
    }

    promptIncomplete() {
      const missing = this.getMissingStages();
      if (!missing.length) return;
      this.activeStageKey = missing[0].key;
      this.setStatus('');
      this.render();
      this.scrollToStage(missing[0].key);
    }

    async addToCart() {
      const selected = this.getSelectedItems();
      if (!selected.length || this.loading) return;

      this.loading = true;
      this.renderSummary();

      const bundleId = `alpe-${Date.now()}`;
      const payload = {
        items: selected.map((item) => ({
          id: item.variant.id,
          quantity: 1,
          properties: {
            '_alpe_bundle_id': bundleId,
            '_alpe_bundle_discount_code': this.discountCode || '',
            '_alpe_bundle_price_mode': this.useRegularPrices ? 'regular' : 'current',
            '_alpe_bundle_regular_price': String(this.getRegularPrice(item.variant)),
            '_alpe_bundle_current_price': String(Number(item.variant.price || 0)),
            '_alpe_bundle_discount_percent': String(this.discountPercent),
            'Komplet': this.bundleName,
            'Kategorija': this.getStageTitle(item.stageKey)
          }
        }))
      };

      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok) throw data;

        if (this.discountCode.trim()) {
          await this.applyDiscountCode();
        }

        const cart = await this.fetchCart();
        const cartForUi = cart || { item_count: selected.length };
        this.updateCartCount(cartForUi);
        this.lastAddedBundleId = bundleId;
        this.addedToCart = cart ? this.cartContainsSelectedBundle(cart, bundleId) : true;
        this.highlightCartButton(cartForUi);
        document.dispatchEvent(new CustomEvent('alpe:bundle:add', { detail: { response: data, cart, bundleId } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { response: data, cart } }));
        if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));

        if (this.afterAdd === 'cart') {
          this.goToCart();
          return;
        }
        this.setStatus('');
      } catch (error) {
        this.setStatus('Kompleta ni bilo mogoče dodati. Preveri izbire in poskusi znova.');
      } finally {
        this.loading = false;
        this.renderSummary();
      }
    }

    async applyDiscountCode() {
      const code = this.discountCode.trim();
      if (!code) return false;
      try {
        const response = await fetch(`${this.root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ discount: code })
        });
        return response.ok;
      } catch (error) {
        return false;
      }
    }

    goToCart() {
      window.location.href = `${this.root}cart`;
    }

    async fetchCart() {
      try {
        const response = await fetch(`${this.root}cart.js`, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
        });
        return await response.json();
      } catch (error) {
        return null;
      }
    }

    async syncCartState(cartOverride) {
      const syncToken = ++this.cartSyncToken;
      const cart = cartOverride || await this.fetchCart();
      if (syncToken !== this.cartSyncToken || !cart) return;

      this.updateCartCount(cart);

      if (!this.isComplete()) {
        this.resetAddedState();
        this.renderSummary();
        return;
      }

      const matchingBundleId = this.findMatchingBundleId(cart);
      this.addedToCart = Boolean(matchingBundleId);
      this.lastAddedBundleId = matchingBundleId || '';
      this.renderSummary();
    }

    findMatchingBundleId(cart) {
      const items = cart && Array.isArray(cart.items) ? cart.items : [];
      const groups = new Map();

      items.forEach((line) => {
        const properties = line.properties || {};
        const bundleId = properties._alpe_bundle_id;
        if (!bundleId || Number(line.quantity || 0) < 1) return;
        if (properties.Komplet !== this.bundleName) return;
        if (Number(properties._alpe_bundle_discount_percent || 0) !== Number(this.discountPercent || 0)) return;
        if (!groups.has(bundleId)) groups.set(bundleId, []);
        groups.get(bundleId).push(line);
      });

      for (const [bundleId, lines] of groups) {
        if (this.cartContainsSelectedBundle({ items: lines }, bundleId)) return bundleId;
      }
      return '';
    }

    cartContainsSelectedBundle(cart, bundleId) {
      const lines = cart && Array.isArray(cart.items) ? cart.items : [];
      return this.getSelectedItems().every((selected) => lines.some((line) => {
        const properties = line.properties || {};
        return properties._alpe_bundle_id === bundleId
          && properties.Komplet === this.bundleName
          && properties.Kategorija === this.getStageTitle(selected.stageKey)
          && Number(properties._alpe_bundle_discount_percent || 0) === Number(this.discountPercent || 0)
          && String(line.variant_id || line.id) === String(selected.variant.id)
          && Number(line.quantity || 0) > 0;
      }));
    }

    restoreSelections() {
      let saved;
      try {
        saved = JSON.parse(window.sessionStorage.getItem(this.storageKey) || 'null');
      } catch (error) {
        return;
      }
      if (!saved || !Array.isArray(saved.items)) return;

      saved.items.forEach((savedItem) => {
        const item = this.products.find((candidate) => candidate.stageKey === savedItem.stageKey
          && (candidate.blockId === savedItem.blockId || String(candidate.product.id) === String(savedItem.productId)));
        if (!item) return;
        const variant = (item.product.variants || []).find((candidate) => String(candidate.id) === String(savedItem.variantId));
        if (!variant || !variant.available) return;

        this.selections[item.stageKey] = this.createSelection(item, variant);
        const state = this.productState.get(item.blockId);
        if (state) {
          state.variant = variant;
          state.selectedOptions = {};
          this.getVisibleOptions(item.product).forEach((option) => {
            state.selectedOptions[option.index] = variant.options[option.index];
          });
          const card = this.cardNodes.get(item.blockId);
          if (card) this.renderOptions(item, card);
        }
      });

      if (saved.activeStageKey && this.stages.some((stage) => stage.key === saved.activeStageKey)) {
        this.activeStageKey = saved.activeStageKey;
      }
      if (this.getSelectedItems().length > 0) this.summaryCollapsed = false;
    }

    persistSelections() {
      const selected = this.getSelectedItems();
      try {
        if (!selected.length) {
          window.sessionStorage.removeItem(this.storageKey);
          return;
        }
        window.sessionStorage.setItem(this.storageKey, JSON.stringify({
          activeStageKey: this.activeStageKey,
          items: selected.map((item) => ({
            stageKey: item.stageKey,
            blockId: item.blockId,
            productId: item.productId,
            variantId: item.variant.id
          }))
        }));
      } catch (error) {
        return;
      }
    }

    resetAddedState() {
      if (!this.addedToCart && !this.lastAddedBundleId) return;
      this.addedToCart = false;
      this.lastAddedBundleId = '';
    }

    createSelection(item, variant) {
      return {
        blockId: item.blockId,
        stageKey: item.stageKey,
        productId: item.product.id,
        variant,
        title: item.displayTitle || item.product.title,
        variantTitle: this.getVariantLabel(item.product, variant),
        image: variant.featuredImage || item.product.featuredImage,
        productUrl: item.product.url
      };
    }

    getVisibleOptions(product) {
      return (product.options || [])
        .map((option, index) => ({ ...option, index }))
        .filter((option) => option.name && option.name !== 'Title' && option.values.some((value) => value !== 'Default Title'));
    }

    needsOptions(product) {
      return this.getVisibleOptions(product).length > 0;
    }

    getInitialVariant(product) {
      const variants = product.variants || [];
      const available = variants.find((variant) => variant.available);
      return available || null;
    }

    findSelectedVariant(item, state) {
      const visibleOptions = this.getVisibleOptions(item.product);
      if (visibleOptions.some((option) => !state.selectedOptions[option.index])) return null;
      return (item.product.variants || []).find((variant) => {
        if (!variant.available) return false;
        return visibleOptions.every((option) => variant.options[option.index] === state.selectedOptions[option.index]);
      }) || null;
    }

    isOptionValueAvailable(item, optionIndex, value, state) {
      const selected = { ...(state ? state.selectedOptions : {}), [optionIndex]: value };
      return (item.product.variants || []).some((variant) => {
        if (!variant.available) return false;
        return Object.entries(selected).every(([index, selectedValue]) => variant.options[Number(index)] === selectedValue);
      });
    }

    getSelectedItems() {
      return this.stages
        .map((stage) => this.selections[stage.key])
        .filter(Boolean);
    }

    getMissingStages() {
      return this.stages.filter((stage) => !this.selections[stage.key]);
    }

    isComplete() {
      return this.stages.length > 0 && this.getMissingStages().length === 0;
    }

    getNextIncompleteStage(currentKey) {
      const currentIndex = this.stages.findIndex((stage) => stage.key === currentKey);
      const afterCurrent = this.stages.slice(currentIndex + 1).find((stage) => !this.selections[stage.key]);
      if (afterCurrent) return afterCurrent;
      return this.stages.find((stage) => !this.selections[stage.key]) || null;
    }

    getStageTitle(stageKey) {
      const stage = this.stages.find((item) => item.key === stageKey);
      return stage ? stage.title : stageKey;
    }

    getVariantLabel(product, variant) {
      if (!variant || !variant.title || variant.title === 'Default Title') return '';
      if (!this.needsOptions(product)) return '';
      return variant.title;
    }

    getSelectionLabel(selection) {
      return selection.variantTitle ? `${selection.title} · ${selection.variantTitle}` : selection.title;
    }

    setCardStatus(blockId, text) {
      const card = this.cardNodes.get(blockId);
      const status = card ? card.querySelector('[data-alpe-card-status]') : null;
      if (status) status.textContent = text;
    }

    setStatus(text, state) {
      if (!this.statusNode) return;
      const nextState = state || (text ? 'message' : 'empty');
      this.statusNode.textContent = text;
      this.statusNode.dataset.alpeStatusState = nextState;
    }

    setText(selector, text) {
      this.querySelectorAll(selector).forEach((node) => {
        node.textContent = text;
      });
    }

    setHtml(selector, html) {
      this.querySelectorAll(selector).forEach((node) => {
        node.innerHTML = html;
      });
    }

    scrollToStage(stageKey) {
      if (this.scrollAnimationFrame) window.cancelAnimationFrame(this.scrollAnimationFrame);

      this.scrollAnimationFrame = window.requestAnimationFrame(() => {
        const target = Array.from(this.querySelectorAll('[data-alpe-stage-section]'))
          .find((section) => section.dataset.stageKey === stageKey);
        if (!target) return;

        const offset = window.matchMedia('(max-width: 760px)').matches ? 92 : 128;
        const start = window.scrollY;
        const destination = Math.max(0, target.getBoundingClientRect().top + start - offset);
        const distance = destination - start;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reduceMotion || Math.abs(distance) < 2) {
          window.scrollTo(0, destination);
          this.scrollAnimationFrame = null;
          return;
        }

        const duration = 750;
        const startedAt = performance.now();
        const easeInOutCubic = (progress) => progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        const animate = (now) => {
          const progress = Math.min((now - startedAt) / duration, 1);
          window.scrollTo(0, start + distance * easeInOutCubic(progress));
          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
          } else {
            this.scrollAnimationFrame = null;
          }
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      });
    }

    updateCartCount(cart) {
      if (!cart) return;
      const hasItems = cart.item_count > 0;
      document.body.classList.toggle('cart-has-items', hasItems);
      document.documentElement.classList.toggle('cart-has-items', hasItems);
      document.querySelectorAll('.cart-link__bubble').forEach((bubble) => {
        bubble.classList.toggle('cart-link__bubble--visible', hasItems);
      });
      document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
      });
    }

    highlightCartButton(cart) {
      if (!cart || cart.item_count <= 0) return;
      const targets = document.querySelectorAll('.site-nav__thumb-cart, .site-nav__link--cart');
      targets.forEach((target) => {
        target.classList.remove('alpe-cart-confirmed');
        void target.offsetWidth;
        target.classList.add('alpe-cart-confirmed');
      });
      window.setTimeout(() => {
        targets.forEach((target) => target.classList.remove('alpe-cart-confirmed'));
      }, 1200);
    }

    formatMoney(cents) {
      return `${(Number(cents || 0) / 100).toFixed(2)} €`;
    }

    getRegularPrice(priceSource) {
      const currentPrice = Number(priceSource && priceSource.price || 0);
      const compareAtPrice = Number(priceSource && priceSource.compareAtPrice || 0);
      return compareAtPrice > currentPrice ? compareAtPrice : currentPrice;
    }

    getPricing(priceSource) {
      const currentPrice = Number(priceSource && priceSource.price || 0);
      const compareAtPrice = Number(priceSource && priceSource.compareAtPrice || 0);

      if (this.useRegularPrices) {
        return {
          price: this.getRegularPrice(priceSource),
          compareAt: 0
        };
      }

      return {
        price: currentPrice,
        compareAt: compareAtPrice > currentPrice ? compareAtPrice : 0
      };
    }

    getBundlePricing(priceSource) {
      const regular = this.getRegularPrice(priceSource);
      const discountPercent = Math.min(100, Math.max(0, Number(this.discountPercent || 0)));
      const discount = Math.round(regular * discountPercent / 100);
      const price = Math.max(regular - discount, 0);

      return {
        regular,
        price,
        compareAt: discount > 0 ? regular : 0
      };
    }
  }

  if (!customElements.get('alpe-tour-bundle-builder')) {
    customElements.define('alpe-tour-bundle-builder', AlpeTourBundleBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpe-tour-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.alpeTourSmoothScrollReady) {
    window.alpeTourSmoothScrollReady = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#alpe-tour-"]');
      if (!link) return;

      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const offset = window.matchMedia('(max-width: 760px)').matches ? 117 : 125;
      const start = window.scrollY;
      const destination = Math.max(0, target.getBoundingClientRect().top + start - offset);

      if (reduceMotion) {
        window.scrollTo(0, destination);
      } else {
        const duration = 850;
        const startedAt = performance.now();
        const easeInOutCubic = (progress) => progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        const animate = (now) => {
          const progress = Math.min((now - startedAt) / duration, 1);
          window.scrollTo(0, start + (destination - start) * easeInOutCubic(progress));
          if (progress < 1) window.requestAnimationFrame(animate);
        };

        window.requestAnimationFrame(animate);
      }

      window.history.replaceState(null, '', link.getAttribute('href'));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpe-tour-product-listing"] && !Shopify.designMode) return;
  try {
    
  class AlpeTourProductListing extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.root = this.dataset.root || '/';
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      const variantButton = event.target.closest('[data-tour-variant]');
      if (variantButton && this.contains(variantButton)) {
        this.selectVariant(variantButton);
        return;
      }

      const addButton = event.target.closest('[data-tour-add]');
      if (addButton && this.contains(addButton)) this.addToCart(addButton);
    }

    selectVariant(button) {
      const card = button.closest('[data-tour-product-card]');
      const addButton = card.querySelector('[data-tour-add]');
      card.querySelectorAll('[data-tour-variant]').forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
      addButton.dataset.selectedVariant = button.dataset.variantId;
      addButton.disabled = false;

      const price = card.querySelector('[data-tour-price]');
      if (price) {
        price.innerHTML = '';
        const comparePrice = Number(button.dataset.comparePriceCents || 0);
        if (comparePrice > 0) {
          const compare = document.createElement('s');
          compare.textContent = this.formatMoney(comparePrice);
          price.appendChild(compare);
        }
        const current = document.createElement('span');
        if (comparePrice > 0) current.className = 'sale-price';
        current.textContent = this.formatMoney(button.dataset.priceCents);
        price.appendChild(current);
      }
    }

    async addToCart(button) {
      const card = button.closest('[data-tour-product-card]');
      const status = card.querySelector('[data-tour-status]');
      const variantId = Number(button.dataset.selectedVariant);
      if (!variantId || button.disabled) return;

      button.disabled = true;
      button.textContent = this.dataset.addingLabel;
      status.textContent = '';

      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || this.dataset.errorLabel);

        const cartResponse = await fetch(`${this.root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = cartResponse.ok ? await cartResponse.json() : null;
        button.textContent = this.dataset.addedLabel;
        this.updateCartCount(cart);
        this.highlightCartButton(cart);
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { response: data, cart } }));
        if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));
        window.setTimeout(() => {
          button.textContent = this.dataset.addLabel;
          button.disabled = false;
        }, 1800);
      } catch (error) {
        status.textContent = error.message || this.dataset.errorLabel;
        button.textContent = this.dataset.addLabel;
        button.disabled = false;
      }
    }

    updateCartCount(cart) {
      if (!cart) return;
      const hasItems = cart.item_count > 0;
      document.body.classList.toggle('cart-has-items', hasItems);
      document.documentElement.classList.toggle('cart-has-items', hasItems);
      document.querySelectorAll('.cart-link__bubble').forEach((bubble) => {
        bubble.classList.toggle('cart-link__bubble--visible', hasItems);
      });
      document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
      });
    }

    highlightCartButton(cart) {
      if (!cart || cart.item_count <= 0) return;
      const targets = document.querySelectorAll('.site-nav__thumb-cart, .site-nav__link--cart');
      targets.forEach((target) => {
        target.classList.remove('alpe-cart-confirmed');
        void target.offsetWidth;
        target.classList.add('alpe-cart-confirmed');
      });
      window.setTimeout(() => targets.forEach((target) => target.classList.remove('alpe-cart-confirmed')), 1200);
    }

    formatMoney(cents) {
      return `${(Number(cents || 0) / 100).toFixed(2)} €`;
    }
  }

  if (!customElements.get('alpe-tour-product-listing')) customElements.define('alpe-tour-product-listing', AlpeTourProductListing);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alpe-ugc-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('alpe-ugc-slider')) {
    class AlpeUgcSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.viewport = this.querySelector('[data-ugc-viewport]');
        this.track = this.querySelector('[data-ugc-track]');
        this.previousButton = this.querySelector('[data-ugc-previous]');
        this.nextButton = this.querySelector('[data-ugc-next]');
        this.controlsTemplate = this.querySelector('[data-ugc-player-controls-template]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.originalCards = this.track ? Array.from(this.track.querySelectorAll('[data-ugc-card]')) : [];

        if (!this.viewport || !this.track) return;
        if (this.originalCards.length === 0) {
          this.setStatic(true);
          return;
        }

        this.initialized = true;
        this.videoTimes = new Map();
        this.sectionInView = false;
        this.activeLogicalIndex = null;
        this.playerSourcesLoaded = false;
        this.sourceGeneration = 0;
        this.soundPreference = 'on';
        this.userPaused = false;
        this.resumeAfterCarouselScroll = false;
        this.resumeAfterVisibility = false;
        this.pendingCardLogicalIndex = null;
        this.isCardAligning = false;
        this.suppressCardClickUntil = 0;
        this.wheelAxisLock = null;
        this.boundPrevious = () => this.move(-1);
        this.boundNext = () => this.move(1);
        this.boundKeydown = (event) => this.onKeydown(event);
        this.boundWheel = (event) => this.onWheel(event);
        this.boundScroll = () => this.onScroll();
        this.boundPointerDown = (event) => this.onPointerDown(event);
        this.boundPointerMove = (event) => this.onPointerMove(event);
        this.boundPointerUp = (event) => this.onPointerUp(event);
        this.boundBlockSelect = (event) => this.onBlockSelect(event);
        this.boundVisibilityChange = () => this.onVisibilityChange();
        this.boundReducedMotionChange = () => this.onReducedMotionChange();
        this.boundRootClick = (event) => this.onRootClick(event);
        this.boundDragStart = (event) => this.onDragStart(event);
        this.boundPlayerActivity = (event) => this.onPlayerActivity(event);
        this.boundPlayerFocusOut = () => this.onPlayerFocusOut();

        this.previousButton.addEventListener('click', this.boundPrevious);
        this.nextButton.addEventListener('click', this.boundNext);
        this.viewport.addEventListener('keydown', this.boundKeydown);
        this.viewport.addEventListener('wheel', this.boundWheel, { passive: false });
        this.viewport.addEventListener('scroll', this.boundScroll, { passive: true });
        this.viewport.addEventListener('pointerdown', this.boundPointerDown);
        this.viewport.addEventListener('pointermove', this.boundPointerMove);
        this.viewport.addEventListener('pointerup', this.boundPointerUp);
        this.viewport.addEventListener('pointercancel', this.boundPointerUp);
        this.viewport.addEventListener('dragstart', this.boundDragStart);
        document.addEventListener('shopify:block:select', this.boundBlockSelect);
        document.addEventListener('visibilitychange', this.boundVisibilityChange);
        this.reducedMotion.addEventListener('change', this.boundReducedMotionChange);
        this.addEventListener('click', this.boundRootClick);
        this.addEventListener('pointerover', this.boundPlayerActivity);
        this.addEventListener('focusin', this.boundPlayerActivity);
        this.addEventListener('focusout', this.boundPlayerFocusOut);

        this.buildLoop();
        this.lastViewportWidth = this.viewport.clientWidth;

        this.resizeObserver = new ResizeObserver((entries) => {
          const nextWidth = entries[0]?.contentRect.width || this.viewport.clientWidth;
          if (Math.abs(nextWidth - this.lastViewportWidth) <= 1) return;

          this.lastViewportWidth = nextWidth;
          window.clearTimeout(this.resizeTimer);
          this.resizeTimer = window.setTimeout(() => this.buildLoop(), 80);
        });
        this.resizeObserver.observe(this.viewport);

        this.sectionObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const ratio = entry?.isIntersecting ? entry.intersectionRatio : 0;

          if (ratio >= 0.35) {
            this.sectionInView = true;
            window.clearTimeout(this.releaseTimer);
            this.warmMediaPosters();
            this.scheduleVideoActivation(0);
            return;
          }

          if (ratio > 0.1) return;

          this.sectionInView = false;
          this.pauseForVisibility();
          this.scheduleSourceRelease();
        }, {
          root: null,
          threshold: [0, 0.1, 0.35]
        });
        this.sectionObserver.observe(this.viewport);
      }

      disconnectedCallback() {
        if (!this.initialized) return;

        this.previousButton.removeEventListener('click', this.boundPrevious);
        this.nextButton.removeEventListener('click', this.boundNext);
        this.viewport.removeEventListener('keydown', this.boundKeydown);
        this.viewport.removeEventListener('wheel', this.boundWheel);
        this.viewport.removeEventListener('scroll', this.boundScroll);
        this.viewport.removeEventListener('pointerdown', this.boundPointerDown);
        this.viewport.removeEventListener('pointermove', this.boundPointerMove);
        this.viewport.removeEventListener('pointerup', this.boundPointerUp);
        this.viewport.removeEventListener('pointercancel', this.boundPointerUp);
        this.viewport.removeEventListener('dragstart', this.boundDragStart);
        document.removeEventListener('shopify:block:select', this.boundBlockSelect);
        document.removeEventListener('visibilitychange', this.boundVisibilityChange);
        this.reducedMotion.removeEventListener('change', this.boundReducedMotionChange);
        this.removeEventListener('click', this.boundRootClick);
        this.removeEventListener('pointerover', this.boundPlayerActivity);
        this.removeEventListener('focusin', this.boundPlayerActivity);
        this.removeEventListener('focusout', this.boundPlayerFocusOut);
        this.resizeObserver?.disconnect();
        this.sectionObserver?.disconnect();
        this.videoObserver?.disconnect();
        this.destroyPlayer();
        window.cancelAnimationFrame(this.scrollFrame);
        window.cancelAnimationFrame(this.videoFrame);
        window.cancelAnimationFrame(this.restoreBehaviorFrame);
        window.cancelAnimationFrame(this.cancelMotionFrame);
        window.clearTimeout(this.resizeTimer);
        window.clearTimeout(this.videoActivationTimer);
        window.clearTimeout(this.releaseTimer);
        window.clearTimeout(this.cardAlignmentTimer);
        window.clearTimeout(this.controlsHideTimer);
        window.clearTimeout(this.wheelAxisTimer);
        this.viewport.style.removeProperty('scroll-behavior');
        this.initialized = false;
      }

      cloneCard(card) {
        const clone = card.cloneNode(true);
        clone.dataset.ugcClone = 'true';
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('data-shopify-editor-block');
        clone.removeAttribute('data-block-id');
        clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => node.removeAttribute('data-shopify-editor-block'));
        clone.querySelectorAll('[data-ugc-video-template], [data-ugc-player-controls], video').forEach((node) => node.remove());
        clone.classList.remove('is-video-active', 'is-video-ready');
        return clone;
      }

      buildLoop() {
        if (!this.viewport || !this.track || this.originalCards.length === 0) return;

        this.cancelCardAlignment();
        const previousSetWidth = this.setWidth;
        const previousLoopStart = this.loopStart || 0;
        const previousPhase = previousSetWidth
          ? (((this.viewport.scrollLeft - previousLoopStart) % previousSetWidth) + previousSetWidth) % previousSetWidth
          : 0;

        this.resumeAfterCarouselScroll = Boolean(this.player && !this.player.paused && !this.userPaused);
        this.pauseActiveVideo();
        this.detachPlayerFromCard();
        this.track.querySelectorAll('[data-ugc-clone]').forEach((clone) => clone.remove());
        this.originalCards = Array.from(this.track.querySelectorAll('[data-ugc-card]:not([data-ugc-clone])'));
        const firstCard = this.originalCards[0];
        const trackStyles = window.getComputedStyle(this.track);
        const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 15;
        this.step = firstCard.getBoundingClientRect().width + gap;
        this.setWidth = this.step * this.originalCards.length;

        if (this.originalCards.length < 2 || this.setWidth <= 0) {
          this.setStatic(true);
          this.viewport.scrollLeft = 0;
          this.setupVideoObserver();
          this.scheduleVideoActivation(80);
          return;
        }

        this.setStatic(false);
        this.edgeBuffer = Math.max(this.step * 1.5, 96);
        const targetRunway = this.step * 2;
        const repeatSets = Math.max(
          1,
          Math.ceil(
            ((this.viewport.clientWidth + this.edgeBuffer + targetRunway + gap + 1) / this.setWidth) - 1
          )
        );
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();

        for (let setIndex = 0; setIndex < repeatSets; setIndex += 1) {
          this.originalCards.forEach((card) => before.appendChild(this.cloneCard(card)));
          this.originalCards.forEach((card) => after.appendChild(this.cloneCard(card)));
        }

        this.track.prepend(before);
        this.track.append(after);
        this.loopStart = repeatSets * this.setWidth;
        const phaseRatio = previousSetWidth ? previousPhase / previousSetWidth : 0;
        this.jumpTo(this.loopStart + (phaseRatio * this.setWidth));
        this.setupVideoObserver();
        this.scheduleVideoActivation(80);
      }

      setStatic(isStatic) {
        this.classList.toggle('is-static', isStatic);
        [this.previousButton, this.nextButton].forEach((button) => {
          if (!button) return;
          button.disabled = isStatic;
          button.setAttribute('aria-disabled', String(isStatic));
        });
      }

      jumpTo(left) {
        if (this.restoreBehaviorFrame) {
          window.cancelAnimationFrame(this.restoreBehaviorFrame);
          this.viewport.style.removeProperty('scroll-behavior');
        }

        const previousBehavior = this.viewport.style.scrollBehavior;
        this.viewport.style.scrollBehavior = 'auto';
        this.viewport.scrollLeft = left;
        this.restoreBehaviorFrame = window.requestAnimationFrame(() => {
          this.reparentPlayerAfterLoopJump();
          if (previousBehavior) {
            this.viewport.style.scrollBehavior = previousBehavior;
          } else {
            this.viewport.style.removeProperty('scroll-behavior');
          }
          this.restoreBehaviorFrame = null;
        });
      }

      reparentPlayerAfterLoopJump() {
        if (!this.player?.isConnected || !this.activeVideoCard || this.activeLogicalIndex === null) return;

        const viewportRect = this.viewport.getBoundingClientRect();
        const equivalentCards = Array.from(this.track.querySelectorAll('[data-ugc-video-card]'))
          .filter((card) => card.dataset.ugcIndex === this.activeLogicalIndex);
        let bestCard = null;
        let bestRatio = 0;

        equivalentCards.forEach((card) => {
          const rect = card.getBoundingClientRect();
          const visibleWidth = Math.max(0, Math.min(rect.right, viewportRect.right) - Math.max(rect.left, viewportRect.left));
          const ratio = rect.width > 0 ? visibleWidth / rect.width : 0;
          if (ratio > bestRatio) {
            bestCard = card;
            bestRatio = ratio;
          }
        });

        if (!bestCard || bestCard === this.activeVideoCard || bestRatio < 0.6) return;

        const frameIsReady = this.activeVideoCard.classList.contains('is-video-ready') && this.player.readyState >= 2;
        this.detachPlayerFromCard();
        this.activeVideoCard = bestCard;
        bestCard.classList.add('is-video-active');
        if (bestCard.dataset.ugcClone === 'true') {
          bestCard.setAttribute('aria-hidden', 'false');
          bestCard.setAttribute('tabindex', '0');
          this.hiddenOriginalCard = this.originalCards.find((item) => item.dataset.ugcIndex === this.activeLogicalIndex) || null;
          this.hiddenOriginalCard?.setAttribute('aria-hidden', 'true');
          this.hiddenOriginalCard?.setAttribute('tabindex', '-1');
        }
        bestCard.append(this.player, this.playerControls);
        if (frameIsReady) bestCard.classList.add('is-video-ready');
        this.updatePlayerControls();
      }

      normalizeLoop() {
        if (!this.setWidth || this.originalCards.length < 2) return;

        const current = this.viewport.scrollLeft;
        const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        const lowerBound = this.edgeBuffer;
        const upperBound = maxScroll - this.edgeBuffer;
        if (current >= lowerBound && current <= upperBound) return;

        let normalized = this.loopStart + (((current - this.loopStart) % this.setWidth) + this.setWidth) % this.setWidth;
        if (normalized > this.loopStart + (this.setWidth / 2)) normalized -= this.setWidth;

        if (Math.abs(normalized - current) > 1) {
          this.rememberVideoTime(this.player);
          this.jumpTo(normalized);
        }
      }

      move(direction) {
        if (!this.step || this.originalCards.length < 2) return;

        this.cancelCardAlignment();
        this.normalizeLoop();
        this.viewport.scrollBy({
          left: direction * this.step,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });
      }

      onKeydown(event) {
        if (event.target.closest('[data-ugc-player-controls]')) return;

        const card = event.target.closest('[data-ugc-card]');
        if (card && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          this.alignCardToLeadingEdge(card);
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1);
        }
      }

      onWheel(event) {
        if (event.ctrlKey || this.originalCards.length < 2) return;

        const shiftedWheel = event.shiftKey && Math.abs(event.deltaY) > 0;
        if (!this.wheelAxisLock) {
          const horizontalIntent = Math.abs(event.deltaX) >= Math.abs(event.deltaY) * 0.75;
          this.wheelAxisLock = shiftedWheel || horizontalIntent ? 'horizontal' : 'vertical';
        }
        window.clearTimeout(this.wheelAxisTimer);
        this.wheelAxisTimer = window.setTimeout(() => {
          this.wheelAxisLock = null;
        }, 120);
        if (this.wheelAxisLock !== 'horizontal') return;

        const rawDelta = shiftedWheel ? event.deltaY : event.deltaX;
        const deltaMultiplier = event.deltaMode === 1
          ? 16
          : event.deltaMode === 2
            ? this.viewport.clientWidth
            : 1;
        const delta = rawDelta * deltaMultiplier;
        if (delta === 0) return;

        event.preventDefault();
        this.cancelCardAlignment(true);
        this.viewport.scrollLeft += delta;
      }

      onScroll() {
        if (!this.isCardAligning && this.player && !this.player.paused && !this.userPaused) {
          this.resumeAfterCarouselScroll = true;
          this.pauseActiveVideo();
        }
        if (this.isCardAligning) {
          window.clearTimeout(this.cardAlignmentTimer);
          this.cardAlignmentTimer = window.setTimeout(() => this.finishCardAlignment(), 160);
        } else {
          this.scheduleVideoActivation(140);
        }
        if (this.scrollFrame) return;

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          if (!this.isPointerDown) this.normalizeLoop();
        });
      }

      onPointerDown(event) {
        if (event.target.closest('[data-ugc-player-controls]')) return;

        this.onPlayerActivity(event);
        if (!event.isPrimary) return;
        this.cancelCardAlignment(true);
        this.gesturePointerId = event.pointerId;
        this.gestureStartX = event.clientX;
        this.gestureStartY = event.clientY;
        this.gestureMoved = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || this.originalCards.length < 2) return;

        this.isPointerDown = true;
        this.isDragging = false;
        this.dragStartX = event.clientX;
        this.dragStartScroll = this.viewport.scrollLeft;
      }

      onPointerMove(event) {
        if (this.gesturePointerId === event.pointerId) {
          const gestureDistance = Math.hypot(event.clientX - this.gestureStartX, event.clientY - this.gestureStartY);
          const gestureThreshold = event.pointerType === 'mouse' ? 5 : 10;
          if (gestureDistance >= gestureThreshold) {
            this.gestureMoved = true;
            this.suppressCardClickUntil = performance.now() + 500;
          }
        }
        this.onPlayerActivity(event);
        if (!this.isPointerDown) return;

        const distance = event.clientX - this.dragStartX;
        if (!this.isDragging && Math.abs(distance) < 5) return;

        if (!this.isDragging) {
          this.isDragging = true;
          this.gestureMoved = true;
          this.suppressCardClickUntil = performance.now() + 500;
          this.viewport.classList.add('is-dragging');
          this.viewport.setPointerCapture(event.pointerId);
        }

        this.viewport.scrollLeft = this.dragStartScroll - distance;
        event.preventDefault();
      }

      onPointerUp(event) {
        const gestureMatches = this.gesturePointerId === event.pointerId;
        if (gestureMatches && (this.gestureMoved || event.type === 'pointercancel')) {
          this.suppressCardClickUntil = performance.now() + 500;
        }
        if (gestureMatches) {
          this.gesturePointerId = null;
          this.gestureMoved = false;
        }
        if (!this.isPointerDown) return;

        this.isPointerDown = false;
        if (!this.isDragging) return;
        this.isDragging = false;
        this.viewport.classList.remove('is-dragging');
        if (this.viewport.hasPointerCapture(event.pointerId)) {
          this.viewport.releasePointerCapture(event.pointerId);
        }
        this.normalizeLoop();
        this.scheduleVideoActivation(140);
      }

      onDragStart(event) {
        if (event.target.closest('[data-ugc-card]')) event.preventDefault();
      }

      onBlockSelect(event) {
        if (!event.detail?.blockId) return;

        const selectedCard = this.originalCards.find((card) => card.dataset.blockId === event.detail.blockId);
        if (!selectedCard) return;

        this.cancelCardAlignment();
        const selectedIndex = this.originalCards.indexOf(selectedCard);
        this.jumpTo(this.loopStart + (selectedIndex * this.step));
      }

      setupVideoObserver() {
        this.videoObserver?.disconnect();
        window.cancelAnimationFrame(this.videoFrame);
        if (!this.viewport) return;

        this.videoVisibility = new Map();
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.videoVisibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });
          this.scheduleVideoActivation(120);
        }, {
          root: this.viewport,
          threshold: [0, 0.35, 0.6, 1]
        });

        this.track.querySelectorAll('[data-ugc-video-card]').forEach((card) => this.videoObserver.observe(card));
      }

      scheduleVideoActivation(delay = 120) {
        window.clearTimeout(this.videoActivationTimer);
        this.videoActivationTimer = window.setTimeout(() => {
          this.videoActivationTimer = null;
          this.activateMostVisibleVideo();
        }, delay);
      }

      activateMostVisibleVideo() {
        if (!this.track || !this.viewport) return;
        if (this.isCardAligning) return;
        if (!this.sectionInView || document.hidden) {
          this.pauseForVisibility();
          return;
        }

        const viewportRect = this.viewport.getBoundingClientRect();
        const videoCards = Array.from(this.track.querySelectorAll('[data-ugc-video-card]'));
        const best = videoCards.reduce((currentBest, card) => {
          const rect = card.getBoundingClientRect();
          const visibleWidth = Math.max(0, Math.min(rect.right, viewportRect.right) - Math.max(rect.left, viewportRect.left));
          const visibleRatio = rect.width > 0 ? visibleWidth / rect.width : 0;
          if (visibleRatio < 0.6) return currentBest;

          const leadingDistance = Math.abs(rect.left - viewportRect.left);
          if (!currentBest || leadingDistance < currentBest.leadingDistance - 1) {
            return { card, leadingDistance, visibleRatio };
          }
          if (Math.abs(leadingDistance - currentBest.leadingDistance) <= 1 && visibleRatio > currentBest.visibleRatio) {
            return { card, leadingDistance, visibleRatio };
          }
          return currentBest;
        }, null);
        const bestCard = best?.card;
        if (!bestCard) return;

        const nextLogicalIndex = bestCard.dataset.ugcIndex;
        if (this.activeLogicalIndex !== null && this.activeLogicalIndex !== nextLogicalIndex) {
          this.userPaused = false;
        }
        const shouldResume = this.resumeAfterVisibility || this.resumeAfterCarouselScroll;
        const autoplay = !this.userPaused && (!this.reducedMotion.matches || shouldResume);
        this.activateVideoCard(bestCard, autoplay);
        this.resumeAfterVisibility = false;
        this.resumeAfterCarouselScroll = false;
      }

      activateVideoCard(card, autoplay) {
        const logicalIndex = card.dataset.ugcIndex;
        if (logicalIndex === undefined) return;

        this.ensurePlayer();
        if (!this.player || !this.playerControls) return;

        if (this.activeVideoCard === card && this.player.isConnected && this.playerSourcesLoaded) {
          this.updatePlayerControls();
          if (autoplay) this.attemptPlay(false);
          return;
        }

        const sameLogicalVideo = this.activeLogicalIndex === logicalIndex && this.playerSourcesLoaded;
        this.detachPlayerFromCard();

        if (!sameLogicalVideo) {
          this.rememberVideoTime(this.player);
          this.configurePlayer(logicalIndex);
        }

        this.activeLogicalIndex = logicalIndex;
        this.activeVideoCard = card;
        card.classList.add('is-video-active');
        if (card.dataset.ugcClone === 'true') {
          card.setAttribute('aria-hidden', 'false');
          card.setAttribute('tabindex', '0');
          this.hiddenOriginalCard = this.originalCards.find((item) => item.dataset.ugcIndex === logicalIndex) || null;
          this.hiddenOriginalCard?.setAttribute('aria-hidden', 'true');
          this.hiddenOriginalCard?.setAttribute('tabindex', '-1');
        }
        card.append(this.player, this.playerControls);

        if (sameLogicalVideo && this.player.readyState >= 2) {
          this.scheduleFrameReveal();
        }
        this.updatePlayerControls();
        this.showPlayerControlsTemporarily();
        if (autoplay) this.attemptPlay(false);
      }

      ensurePlayer() {
        if (this.player) return;

        this.player = document.createElement('video');
        this.player.id = this.dataset.playerId;
        this.player.className = 'alpe-ugc__media';
        this.player.controls = false;
        this.player.autoplay = false;
        this.player.playsInline = true;
        this.player.preload = 'metadata';
        this.player.muted = this.soundPreference === 'muted';
        this.player.addEventListener('loadedmetadata', () => this.restoreVideoTime(this.player));
        this.player.addEventListener('loadeddata', () => this.scheduleFrameReveal());
        this.player.addEventListener('playing', () => {
          this.scheduleFrameReveal();
          this.updatePlayerControls();
          this.showPlayerControlsTemporarily();
        });
        this.player.addEventListener('play', () => this.updatePlayerControls());
        this.player.addEventListener('pause', () => this.updatePlayerControls());
        this.player.addEventListener('volumechange', () => this.updatePlayerControls());
        this.player.addEventListener('error', () => {
          this.activeVideoCard?.classList.remove('is-video-ready');
          this.updatePlayerControls();
          this.keepPlayerControlsVisible();
        });
        this.player.addEventListener('ended', () => this.onVideoEnded());

        const controls = this.controlsTemplate?.content.querySelector('[data-ugc-player-controls]');
        this.playerControls = controls?.cloneNode(true) || null;
      }

      configurePlayer(logicalIndex) {
        const originalCard = this.originalCards.find((item) => item.dataset.ugcIndex === logicalIndex);
        const template = originalCard?.querySelector('[data-ugc-video-template]');
        const templateVideo = template?.content.querySelector('video');
        if (!templateVideo || !this.player) return;

        this.releasePlayerSources();
        this.player.className = templateVideo.className || 'alpe-ugc__media';
        this.player.poster = templateVideo.poster;
        this.player.dataset.ugcIndex = logicalIndex;
        this.player.muted = this.soundPreference === 'muted';
        const accessibleLabel = templateVideo.getAttribute('aria-label') || originalCard.getAttribute('aria-label');
        if (accessibleLabel) this.player.setAttribute('aria-label', accessibleLabel);
        this.player.replaceChildren(...Array.from(templateVideo.childNodes, (node) => node.cloneNode(true)));
        this.sourceGeneration += 1;
        this.playerSourcesLoaded = true;
        this.player.load();
      }

      attemptPlay(userInitiated) {
        if (!this.player || !this.playerSourcesLoaded || !this.sectionInView || document.hidden) return;
        if (!userInitiated && (this.userPaused || this.reducedMotion.matches)) return;

        const video = this.player;
        const generation = this.sourceGeneration;
        const logicalIndex = this.activeLogicalIndex;
        const card = this.activeVideoCard;
        const playResult = video.play();
        if (!playResult?.catch) {
          this.updatePlayerControls();
          return;
        }

        playResult.catch((error) => {
          if (
            this.player !== video
            || this.sourceGeneration !== generation
            || this.activeLogicalIndex !== logicalIndex
            || this.activeVideoCard !== card
            || !this.sectionInView
            || document.hidden
            || this.userPaused
            || (!userInitiated && this.reducedMotion.matches)
          ) return;

          if (error?.name === 'NotAllowedError' && !video.muted) {
            video.muted = true;
            this.soundPreference = 'muted';
            this.updatePlayerControls();
            video.play().catch(() => this.updatePlayerControls());
            return;
          }
          this.updatePlayerControls();
        });
      }

      scheduleFrameReveal() {
        if (!this.player || !this.activeVideoCard || this.player.readyState < 2) return;

        const video = this.player;
        const card = this.activeVideoCard;
        const logicalIndex = this.activeLogicalIndex;
        const generation = this.sourceGeneration;
        const reveal = () => {
          if (
            this.player !== video
            || this.activeVideoCard !== card
            || this.activeLogicalIndex !== logicalIndex
            || this.sourceGeneration !== generation
          ) return;
          card.classList.add('is-video-ready');
        };

        if ('requestVideoFrameCallback' in video && !video.paused) {
          video.requestVideoFrameCallback(() => window.requestAnimationFrame(reveal));
          return;
        }

        window.requestAnimationFrame(() => window.requestAnimationFrame(reveal));
      }

      updatePlayerControls() {
        if (!this.player || !this.playerControls) return;

        const isPlaying = !this.player.paused && !this.player.ended && !this.player.error;
        const isMuted = this.player.muted || this.player.volume === 0;
        const playButton = this.playerControls.querySelector('[data-ugc-play-toggle]');
        const muteButton = this.playerControls.querySelector('[data-ugc-mute-toggle]');
        this.playerControls.dataset.playing = String(isPlaying);
        this.playerControls.dataset.muted = String(isMuted);

        if (playButton) {
          playButton.setAttribute('aria-label', isPlaying ? this.dataset.pauseLabel : this.dataset.playLabel);
        }
        if (muteButton) {
          muteButton.setAttribute('aria-label', isMuted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
          muteButton.setAttribute('aria-pressed', String(!isMuted));
        }
        if (!isPlaying) this.keepPlayerControlsVisible();
      }

      showPlayerControlsTemporarily() {
        if (!this.playerControls) return;

        window.clearTimeout(this.controlsHideTimer);
        this.playerControls.classList.remove('is-play-control-idle');
        if (!this.player || this.player.paused || this.player.ended) return;
        this.controlsHideTimer = window.setTimeout(() => {
          if (
            !this.playerControls
            || !this.player
            || this.player.paused
            || this.player.ended
            || this.isDragging
            || this.activeVideoCard?.matches(':focus-within')
          ) return;
          this.playerControls.classList.add('is-play-control-idle');
        }, 2000);
      }

      keepPlayerControlsVisible() {
        window.clearTimeout(this.controlsHideTimer);
        this.playerControls?.classList.remove('is-play-control-idle');
      }

      onPlayerActivity(event) {
        if (!this.activeVideoCard || !event.target?.closest) return;
        const activityCard = event.target.closest('[data-ugc-card]');
        if (activityCard === this.activeVideoCard) this.showPlayerControlsTemporarily();
      }

      onPlayerFocusOut() {
        window.requestAnimationFrame(() => {
          if (!this.playerControls?.contains(document.activeElement)) this.showPlayerControlsTemporarily();
        });
      }

      onRootClick(event) {
        const playButton = event.target.closest('[data-ugc-play-toggle]');
        const muteButton = event.target.closest('[data-ugc-mute-toggle]');
        if (playButton || muteButton) {
          event.preventDefault();
          event.stopPropagation();
          if (!this.player) return;

          this.showPlayerControlsTemporarily();
          if (playButton) {
            if (this.player.paused) {
              this.userPaused = false;
              this.attemptPlay(true);
            } else {
              this.userPaused = true;
              this.pauseActiveVideo();
            }
            return;
          }

          const wasPlaying = !this.player.paused;
          if (this.player.muted || this.player.volume === 0) {
            this.soundPreference = 'on';
            this.player.muted = false;
            if (this.player.volume === 0) this.player.volume = 1;
            if (wasPlaying) this.attemptPlay(true);
          } else {
            this.soundPreference = 'muted';
            this.player.muted = true;
          }
          this.updatePlayerControls();
          return;
        }

        const card = event.target.closest('[data-ugc-card]');
        if (!card || !this.track.contains(card)) return;
        if (performance.now() < this.suppressCardClickUntil) {
          event.preventDefault();
          return;
        }

        event.preventDefault();
        this.alignCardToLeadingEdge(card);
      }

      alignCardToLeadingEdge(card) {
        const logicalIndex = card?.dataset.ugcIndex;
        if (logicalIndex === undefined || !this.viewport || !this.track) return;

        this.cancelCardAlignment();
        window.clearTimeout(this.videoActivationTimer);
        this.pendingCardLogicalIndex = logicalIndex;
        this.isCardAligning = true;
        const isVideoCard = card.hasAttribute('data-ugc-video-card');
        if (isVideoCard) {
          this.userPaused = false;
          this.activateVideoCard(card, false);
          this.attemptPlay(true);
          this.showPlayerControlsTemporarily();
        } else {
          this.pauseActiveVideo();
        }

        const target = this.getCardScrollTarget(card);
        const distance = Math.abs(this.viewport.scrollLeft - target);
        if (distance <= 1) {
          this.cardAlignmentTimer = window.setTimeout(() => this.finishCardAlignment(), 0);
          return;
        }

        this.viewport.scrollTo({
          left: target,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });
        window.clearTimeout(this.cardAlignmentTimer);
        this.cardAlignmentTimer = window.setTimeout(() => this.finishCardAlignment(), 500);
      }

      getCardScrollTarget(card) {
        const viewportRect = this.viewport.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        return Math.max(0, Math.min(maxScroll, this.viewport.scrollLeft + cardRect.left - viewportRect.left));
      }

      findLeadingEquivalentCard(logicalIndex) {
        if (logicalIndex === null || logicalIndex === undefined) return null;

        const viewportRect = this.viewport.getBoundingClientRect();
        return Array.from(this.track.querySelectorAll('[data-ugc-card]'))
          .filter((card) => card.dataset.ugcIndex === logicalIndex)
          .reduce((best, card) => {
            const distance = Math.abs(card.getBoundingClientRect().left - viewportRect.left);
            if (!best || distance < best.distance) return { card, distance };
            return best;
          }, null)?.card || null;
      }

      finishCardAlignment() {
        if (!this.isCardAligning || this.pendingCardLogicalIndex === null) return;

        window.clearTimeout(this.cardAlignmentTimer);
        const logicalIndex = this.pendingCardLogicalIndex;
        this.normalizeLoop();
        window.requestAnimationFrame(() => {
          if (!this.isCardAligning || this.pendingCardLogicalIndex !== logicalIndex) return;

          const card = this.findLeadingEquivalentCard(logicalIndex);
          if (card) {
            const remainingDistance = Math.abs(this.viewport.scrollLeft - this.getCardScrollTarget(card));
            if (remainingDistance > 2) {
              this.viewport.style.scrollBehavior = 'auto';
              this.viewport.scrollLeft = this.getCardScrollTarget(card);
              this.viewport.style.removeProperty('scroll-behavior');
            }
            if (card.hasAttribute('data-ugc-video-card')) {
              this.userPaused = false;
              this.activateVideoCard(card, true);
            } else {
              this.pauseActiveVideo();
            }
          }

          this.pendingCardLogicalIndex = null;
          this.isCardAligning = false;
        });
      }

      cancelCardAlignment(stopMotion = false) {
        window.clearTimeout(this.cardAlignmentTimer);
        this.pendingCardLogicalIndex = null;
        this.isCardAligning = false;
        if (!stopMotion || !this.viewport) return;

        window.cancelAnimationFrame(this.cancelMotionFrame);
        const previousBehavior = this.viewport.style.scrollBehavior;
        const currentScroll = this.viewport.scrollLeft;
        this.viewport.style.scrollBehavior = 'auto';
        this.viewport.scrollTo({ left: currentScroll, behavior: 'auto' });
        this.cancelMotionFrame = window.requestAnimationFrame(() => {
          if (previousBehavior) {
            this.viewport.style.scrollBehavior = previousBehavior;
          } else {
            this.viewport.style.removeProperty('scroll-behavior');
          }
          this.cancelMotionFrame = null;
        });
      }

      getLogicalIndex(video) {
        return video?.dataset.ugcIndex || video?.closest('[data-ugc-index]')?.dataset.ugcIndex;
      }

      rememberVideoTime(video) {
        const logicalIndex = this.getLogicalIndex(video);
        if (logicalIndex === undefined || !Number.isFinite(video?.currentTime)) return;
        this.videoTimes.set(logicalIndex, video.currentTime);
      }

      restoreVideoTime(video) {
        const logicalIndex = this.getLogicalIndex(video);
        const savedTime = this.videoTimes.get(logicalIndex);
        if (savedTime === undefined || !Number.isFinite(video.duration) || video.duration <= 0) return;

        const targetTime = savedTime % video.duration;
        if (Math.abs(video.currentTime - targetTime) > 0.25) {
          try {
            video.currentTime = targetTime;
          } catch {
            return;
          }
        }
      }

      pauseActiveVideo() {
        if (!this.player) return;
        this.player.pause();
        this.updatePlayerControls();
      }

      pauseForVisibility() {
        this.resumeAfterVisibility = Boolean(this.player && !this.player.paused && !this.userPaused);
        this.pauseActiveVideo();
      }

      detachPlayerFromCard() {
        if (this.activeVideoCard?.dataset.ugcClone === 'true') {
          this.activeVideoCard.setAttribute('aria-hidden', 'true');
          this.activeVideoCard.setAttribute('tabindex', '-1');
        }
        this.hiddenOriginalCard?.removeAttribute('aria-hidden');
        this.hiddenOriginalCard?.setAttribute('tabindex', '0');
        this.hiddenOriginalCard = null;
        this.activeVideoCard?.classList.remove('is-video-active', 'is-video-ready');
        this.player?.remove();
        this.playerControls?.remove();
        this.activeVideoCard = null;
      }

      releasePlayerSources() {
        if (!this.player || !this.playerSourcesLoaded) return;
        this.sourceGeneration += 1;
        this.rememberVideoTime(this.player);
        this.player.pause();
        this.player.removeAttribute('src');
        this.player.replaceChildren();
        this.player.load();
        this.playerSourcesLoaded = false;
      }

      scheduleSourceRelease() {
        window.clearTimeout(this.releaseTimer);
        this.releaseTimer = window.setTimeout(() => {
          if (this.sectionInView && !document.hidden) return;
          this.activeVideoCard?.classList.remove('is-video-ready');
          this.releasePlayerSources();
        }, 30000);
      }

      destroyPlayer() {
        this.keepPlayerControlsVisible();
        this.rememberVideoTime(this.player);
        this.detachPlayerFromCard();
        this.releasePlayerSources();
        this.player = null;
        this.playerControls = null;
        this.activeLogicalIndex = null;
      }

      warmMediaPosters() {
        this.track?.querySelectorAll('.alpe-ugc__media:is(img)').forEach((image) => {
          image.loading = 'eager';
          image.decode?.().catch(() => {});
        });
      }

      onVideoEnded() {
        if (!this.player || !this.sectionInView || document.hidden || this.userPaused || this.reducedMotion.matches) return;
        try {
          this.player.currentTime = 0;
        } catch {
          return;
        }
        this.attemptPlay(false);
      }

      onReducedMotionChange() {
        if (this.reducedMotion.matches) {
          this.pauseActiveVideo();
          return;
        }
        if (this.sectionInView) this.scheduleVideoActivation(0);
      }

      onVisibilityChange() {
        if (document.hidden) {
          this.pauseForVisibility();
          this.scheduleSourceRelease();
          return;
        }

        if (this.sectionInView) {
          window.clearTimeout(this.releaseTimer);
          this.scheduleVideoActivation(0);
        } else {
          this.scheduleSourceRelease();
        }
      }
    }

    customElements.define('alpe-ugc-slider', AlpeUgcSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle"] && !Shopify.designMode) return;
  try {
    
  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.root = this.dataset.root || '/';
      this.currency = this.dataset.currency || 'EUR';
      this.bundleName = this.dataset.bundleName || 'Alpe komplet';
      this.useRegularPrices = this.dataset.useRegularPrices === 'true';
      this.discountPercent = Number(this.dataset.discountPercent || 0);
      this.discountCode = this.dataset.discountCode || '';
      this.afterAdd = 'cart';
      this.completeLabel = this.dataset.completeLabel || 'Dodaj komplet v košarico';
      this.incompleteLabel = this.dataset.incompleteLabel || 'Dopolni komplet';
      this.addedLabel = 'Komplet je v košarici';
      this.statusNode = this.querySelector('[data-alpe-status]');
      this.stageStatusNode = this.querySelector('[data-alpe-stage-status]');
      this.summarySlotsNode = this.querySelector('[data-alpe-summary-slots]');
      this.summaryBadgeNode = this.querySelector('[data-alpe-summary-badge]');
      this.summaryDiscountValueNode = this.querySelector('[data-alpe-summary-discount-value]');
      this.summaryDiscountPercentNode = this.querySelector('[data-alpe-summary-discount-percent]');
      this.summaryDiscountPercentWrapNode = this.querySelector('[data-alpe-summary-discount-percent-wrap]');
      this.summaryNode = this.querySelector('[data-alpe-summary]');
      this.heroNode = this.querySelector('.alpe-bundle__hero');
      this.heroVideos = Array.from(this.querySelectorAll('.alpe-bundle__hero-video'));
      this.footerNode = null;
      this.summaryProgressNode = this.querySelector('[data-alpe-summary-progress]');
      this.summaryToggle = this.querySelector('[data-alpe-summary-toggle]');
      this.summaryToggleText = this.querySelector('[data-alpe-summary-toggle-text]');
      this.progressNode = this.querySelector('[data-alpe-progress]');
      this.progressCompleteNode = this.querySelector('[data-alpe-progress-complete]');
      this.savingsStepNode = this.querySelector('[data-alpe-savings-step]');
      this.heroCta = this.querySelector('.alpe-bundle__hero-cta');
      this.removeIconTemplate = this.querySelector('[data-alpe-remove-icon]');
      this.plusIconTemplate = this.querySelector('[data-alpe-plus-icon]');
      this.emptyStageNode = this.querySelector('[data-alpe-empty-stage]');
      this.submitButtons = Array.from(this.querySelectorAll('[data-alpe-submit]'));
      this.cardNodes = new Map();
      this.productState = new Map();
      this.selections = {};
      this.activeFilters = new Map();
      this.loading = false;
      this.addedToCart = false;
      this.submitError = false;
      this.lastAddedBundleId = '';
      this.cartSyncToken = 0;
      this.scrollAnimationFrame = null;
      this.mobileSummaryQuery = window.matchMedia('(max-width: 760px)');
      this.heroMediaQuery = window.matchMedia('(max-width: 760px)');
      this.heroMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.summaryCollapsed = true;

      const data = this.readData();
      this.stages = data.stages || [];
      this.products = data.products || [];
      this.configurationValid = this.stages.length >= 2
        && this.stages.length <= 4
        && new Set(this.stages.map((stage) => stage.key)).size === this.stages.length;
      this.activeStageKey = this.stages[0] ? this.stages[0].key : '';
      this.storageKey = `alpeBundle:v3:${window.location.pathname}:${this.id || 'default'}`;

      this.handlePageShow = () => this.syncCartState();
      this.handleVisibilityChange = () => {
        if (!document.hidden) this.syncCartState();
        this.syncHeroMediaPlayback();
      };
      this.handleCartUpdated = (event) => this.syncCartState(event.detail && event.detail.cart);
      this.handleWindowScroll = () => {
        if (this.summaryVisibilityFrame) return;
        this.summaryVisibilityFrame = window.requestAnimationFrame(() => {
          this.summaryVisibilityFrame = null;
          this.updateSummaryVisibility();
        });
      };
      this.handleWindowResize = () => this.handleWindowScroll();
      this.handleHeroMediaChange = () => this.syncHeroMediaPlayback();

      this.style.setProperty('--alpe-stage-count', Math.max(this.stages.length, 1));
      this.indexCards();
      this.bindTabs();
      this.bindFilters();
      this.bindCards();
      this.restoreSelections();
      this.bindSubmit();
      this.bindSummaryToggle();
      this.bindSummarySlots();
      this.bindHeroCta();
      window.addEventListener('pageshow', this.handlePageShow);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      document.addEventListener('cart:updated', this.handleCartUpdated);
      window.addEventListener('scroll', this.handleWindowScroll, { passive: true });
      window.addEventListener('resize', this.handleWindowResize, { passive: true });
      this.heroMediaQuery.addEventListener('change', this.handleHeroMediaChange);
      this.heroMotionQuery.addEventListener('change', this.handleHeroMediaChange);
      this.render();
      this.syncHeroMediaPlayback();
      this.syncCartState();
    }

    disconnectedCallback() {
      if (this.scrollAnimationFrame) window.cancelAnimationFrame(this.scrollAnimationFrame);
      window.removeEventListener('pageshow', this.handlePageShow);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      document.removeEventListener('cart:updated', this.handleCartUpdated);
      window.removeEventListener('scroll', this.handleWindowScroll);
      window.removeEventListener('resize', this.handleWindowResize);
      this.heroMediaQuery.removeEventListener('change', this.handleHeroMediaChange);
      this.heroMotionQuery.removeEventListener('change', this.handleHeroMediaChange);
      this.heroVideos.forEach((video) => video.pause());
    }

    syncHeroMediaPlayback() {
      this.heroVideos.forEach((video) => {
        const media = video.closest('.alpe-bundle__hero-media');
        const isActive = media && window.getComputedStyle(media).display !== 'none';
        const shouldPlay = isActive && !document.hidden && !this.heroMotionQuery.matches;

        video.muted = true;
        if (!shouldPlay) {
          video.pause();
          return;
        }

        const playRequest = video.play();
        if (playRequest && typeof playRequest.catch === 'function') {
          playRequest.catch(() => {});
        }
      });
    }

    getFooterNode() {
      if (!this.footerNode || !this.footerNode.isConnected) {
        this.footerNode = document.querySelector('#shopify-section-footer, footer[role="contentinfo"], footer, .site-footer');
      }
      return this.footerNode;
    }

    isSummaryOverFooter() {
      if (!this.summaryNode || !this.mobileSummaryQuery.matches) return false;

      const footerNode = this.getFooterNode();
      if (!footerNode) return false;

      const footerRect = footerNode.getBoundingClientRect();
      const summaryHeight = this.summaryNode.offsetHeight;
      const summaryBottomValue = Number.parseFloat(window.getComputedStyle(this.summaryNode).bottom);
      const summaryBottom = Number.isFinite(summaryBottomValue) ? Math.max(summaryBottomValue, 0) : 0;
      const summaryTop = window.innerHeight - summaryBottom - summaryHeight;
      const summaryBottomEdge = window.innerHeight - summaryBottom;

      return footerRect.top < summaryBottomEdge && footerRect.bottom > summaryTop;
    }

    updateSummaryVisibility() {
      if (!this.summaryNode) return;
      const heroBottom = this.heroNode ? this.heroNode.getBoundingClientRect().bottom : 0;
      const reachedBuilder = !this.heroNode || heroBottom <= 140;
      const isFooterHidden = this.isSummaryOverFooter();
      const isVisible = reachedBuilder && !isFooterHidden;

      this.summaryNode.classList.toggle('is-visible', isVisible);
      this.summaryNode.classList.toggle('is-footer-hidden', isFooterHidden);
      this.summaryNode.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }

    readData() {
      const node = this.querySelector('[data-alpe-bundle-data]');
      if (!node) return { stages: [], products: [] };
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        this.setStatus('Konfiguracija kompleta ni pravilno naložena.');
        return { stages: [], products: [] };
      }
    }

    indexCards() {
      this.querySelectorAll('[data-alpe-product-card]').forEach((card) => {
        this.cardNodes.set(card.dataset.alpeProductCard, card);
      });
    }

    bindTabs() {
      this.querySelectorAll('[data-alpe-stage-tab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          this.activeStageKey = tab.dataset.stageKey;
          this.render();
          this.scrollToStage(tab.dataset.stageKey);
        });
      });
    }

    bindCards() {
      this.products.forEach((item) => {
        const card = this.cardNodes.get(item.blockId);
        if (!card) return;
        const initialVariant = this.getInitialVariant(item.product);
        const selectedOptions = {};
        if (initialVariant) {
          this.getVisibleOptions(item.product).forEach((option) => {
            selectedOptions[option.index] = initialVariant.options[option.index];
          });
        }
        const state = {
          selectedOptions,
          variant: initialVariant
        };
        this.productState.set(item.blockId, state);
        this.renderOptions(item, card);

        const button = card.querySelector('[data-alpe-product-submit]');
        if (button) {
          button.addEventListener('click', () => this.selectProduct(item));
        }
      });
    }

    bindFilters() {
      this.querySelectorAll('[data-alpe-filter]').forEach((button) => {
        const stageKey = button.dataset.stageKey;
        const tag = button.dataset.filterTag;
        const group = button.dataset.filterGroup || tag;
        if (button.getAttribute('aria-pressed') === 'true') {
          if (!this.activeFilters.has(stageKey)) this.activeFilters.set(stageKey, new Map());
          this.activeFilters.get(stageKey).set(group, tag);
        }
        button.addEventListener('click', () => {
          if (!this.activeFilters.has(stageKey)) this.activeFilters.set(stageKey, new Map());
          const stageFilters = this.activeFilters.get(stageKey);
          if (stageFilters.get(group) === tag) {
            stageFilters.delete(group);
          } else {
            stageFilters.set(group, tag);
          }
          this.render();
        });
      });
    }

    bindSubmit() {
      this.submitButtons.forEach((button) => {
        button.addEventListener('click', () => this.handleSubmit());
      });
    }

    bindSummaryToggle() {
      if (!this.summaryToggle || !this.summaryNode) return;
      this.summaryToggle.addEventListener('click', () => {
        this.summaryCollapsed = !this.summaryCollapsed;
        this.renderSummaryState();
        this.updateSummaryVisibility();
      });
    }

    bindSummarySlots() {
      if (!this.summarySlotsNode || this.summarySlotsBound) return;
      this.summarySlotsBound = true;
      this.summarySlotsNode.addEventListener('click', (event) => {
        const slot = event.target instanceof Element
          ? event.target.closest('.alpe-bundle__slot')
          : null;
        if (!slot || !this.summarySlotsNode.contains(slot)) return;
        if (event.target.closest('.alpe-bundle__slot-remove')) return;

        const stageKey = slot.dataset.stageKey;
        if (!stageKey) return;

        this.activeStageKey = stageKey;
        this.setStatus('');
        this.render();
        this.scrollToStage(stageKey);
      });
    }

    bindHeroCta() {
      if (!this.heroCta || this.heroCtaBound) return;
      this.heroCtaBound = true;
      this.heroCta.addEventListener('click', (event) => {
        const target = this.querySelector('.alpe-bundle__shell');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    renderSummaryState() {
      if (!this.summaryNode) return;
      this.summaryNode.classList.toggle('is-collapsed', this.summaryCollapsed);
      if (this.summaryToggle) {
        this.summaryToggle.setAttribute('aria-expanded', this.summaryCollapsed ? 'false' : 'true');
        this.summaryToggle.setAttribute('aria-label', this.summaryCollapsed ? 'Odpri povzetek kompleta' : 'Zapri povzetek kompleta');
      }
      if (this.summaryToggleText) {
        this.summaryToggleText.textContent = this.summaryCollapsed ? 'Odpri' : 'Skrij';
      }
    }

    render() {
      this.renderTabs();
      this.renderFilters();
      this.renderCards();
      this.renderSummary();
      this.renderStageStatus();
      this.persistSelections();
    }

    renderTabs() {
      const isBundleComplete = this.isComplete();
      this.querySelectorAll('[data-alpe-stage-tab]').forEach((tab) => {
        const key = tab.dataset.stageKey;
        const isActive = key === this.activeStageKey;
        const isComplete = Boolean(this.selections[key]);
        tab.classList.toggle('is-active', isActive);
        tab.classList.toggle('is-complete', isComplete);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      if (this.savingsStepNode) {
        this.savingsStepNode.classList.toggle('is-complete', isBundleComplete);
      }
      if (this.progressNode) {
        this.progressNode.classList.toggle('is-bundle-complete', isBundleComplete);
        this.progressNode.setAttribute('role', isBundleComplete ? 'group' : 'tablist');
        this.progressNode.setAttribute('aria-label', isBundleComplete ? 'Popust kompleta je aktiven' : 'Kategorije kompleta');
      }
      if (this.progressCompleteNode) {
        this.progressCompleteNode.hidden = !isBundleComplete;
      }
      this.querySelectorAll('[data-alpe-stage-section]').forEach((section) => {
        section.hidden = section.dataset.stageKey !== this.activeStageKey;
      });
    }

    renderFilters() {
      this.querySelectorAll('[data-alpe-filter]').forEach((button) => {
        const stageFilters = this.activeFilters.get(button.dataset.stageKey);
        const group = button.dataset.filterGroup || button.dataset.filterTag;
        const active = Boolean(stageFilters && stageFilters.get(group) === button.dataset.filterTag);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    renderCards() {
      const visibleByStage = new Map();
      this.products.forEach((item) => {
        const card = this.cardNodes.get(item.blockId);
        if (!card) return;
        const visible = this.productMatchesFilters(item);
        card.hidden = !visible;
        if (visible) visibleByStage.set(item.stageKey, (visibleByStage.get(item.stageKey) || 0) + 1);
        this.updateCard(item, card);
      });
      this.querySelectorAll('[data-alpe-filter-empty]').forEach((node) => {
        const stage = node.closest('[data-alpe-stage-section]');
        node.hidden = !stage || (visibleByStage.get(stage.dataset.stageKey) || 0) > 0;
      });
    }

    productMatchesFilters(item) {
      const tags = (item.product.tags || []).map((tag) => String(tag).trim().toLowerCase());
      const relevantFilters = ['all', item.stageKey]
        .map((key) => this.activeFilters.get(key))
        .filter(Boolean)
        .flatMap((filters) => Array.from(filters.values()));
      if (relevantFilters.length === 0) return true;
      return relevantFilters.every((tag) => tags.includes(String(tag).trim().toLowerCase()));
    }

    renderOptions(item, card) {
      const optionsRoot = card.querySelector('[data-alpe-options]');
      if (!optionsRoot) return;
      optionsRoot.innerHTML = '';

      const optionList = this.getVisibleOptions(item.product);
      if (optionList.length === 0) return;

      optionList.forEach((option) => {
        const group = document.createElement('div');
        group.className = 'alpe-bundle__option-group';

        const label = document.createElement('div');
        label.className = 'alpe-bundle__option-label';
        label.textContent = option.name;

        const values = document.createElement('div');
        values.className = 'alpe-bundle__option-values';

        option.values.forEach((value) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'alpe-bundle__option-button';
          button.textContent = value;
          button.dataset.optionIndex = option.index;
          button.dataset.optionValue = value;
          button.addEventListener('click', () => {
            const state = this.productState.get(item.blockId);
            state.selectedOptions[option.index] = value;
            state.variant = this.findSelectedVariant(item, state);
            this.resetAddedState();
            this.renderOptions(item, card);
            this.updateCard(item, card);
          });
          values.appendChild(button);
        });

        group.appendChild(label);
        group.appendChild(values);
        optionsRoot.appendChild(group);
      });

      this.updateOptionButtons(item, card);
    }

    updateOptionButtons(item, card) {
      const state = this.productState.get(item.blockId);
      if (!state) return;

      card.querySelectorAll('[data-option-index]').forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex);
        const value = button.dataset.optionValue;
        const selected = state.selectedOptions[optionIndex] === value;
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        button.disabled = !this.isOptionValueAvailable(item, optionIndex, value, state);
      });
    }

    updateCard(item, card) {
      const state = this.productState.get(item.blockId);
      const selection = this.selections[item.stageKey];
      const isSelected = selection && selection.blockId === item.blockId;
      const variant = state ? state.variant : null;
      const priceNode = card.querySelector('[data-alpe-card-price]');
      const cta = card.querySelector('[data-alpe-product-submit]');
      const status = card.querySelector('[data-alpe-card-status]');

      card.classList.toggle('is-selected', Boolean(isSelected));
      this.updateOptionButtons(item, card);

      if (priceNode) {
        const pricing = this.getPricing(variant || item.product);
        priceNode.innerHTML = `${pricing.compareAt ? `<s>${this.formatMoney(pricing.compareAt)}</s>` : ''}<span>${this.formatMoney(pricing.price)}</span>`;
      }

      if (cta) {
        const needsOptions = this.needsOptions(item.product);
        const available = item.product.available && (!variant || variant.available);
        cta.disabled = !item.product.available;
        if (!item.product.available) {
          cta.textContent = 'Razprodano';
        } else if (isSelected) {
          cta.textContent = 'Dodano v komplet';
        } else if (needsOptions && !variant) {
          cta.textContent = 'Izberi velikost';
        } else {
          cta.textContent = 'Dodaj izdelek v komplet';
        }
        if (!available) cta.disabled = true;
      }

      if (status) {
        status.textContent = '';
      }
    }

    renderSummary() {
      if (this.summarySlotsNode) {
        this.summarySlotsNode.innerHTML = '';
        this.stages.forEach((stage) => {
          const selected = this.selections[stage.key];
          const slot = document.createElement('div');
          slot.className = `alpe-bundle__slot${selected ? ' is-filled' : ''}`;
          slot.dataset.stageKey = stage.key;
          if (selected) slot.dataset.variantId = String(selected.variant.id);

          const box = document.createElement('button');
          box.type = 'button';
          box.className = 'alpe-bundle__slot-box';
          box.dataset.alpeSummaryStage = stage.key;
          box.setAttribute('aria-label', selected ? `${stage.title}: ${this.getSelectionLabel(selected)}` : `${stage.title}: izberi izdelek`);

          let remove = null;
          if (selected) {
            if (selected.image) {
              const image = document.createElement('img');
              image.className = 'alpe-bundle__slot-image';
              image.src = selected.image;
              image.alt = selected.title;
              box.appendChild(image);
            }
            remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'alpe-bundle__slot-remove';
            remove.setAttribute('aria-label', `Odstrani ${stage.title}`);
            if (this.removeIconTemplate) remove.appendChild(this.removeIconTemplate.content.cloneNode(true));
            remove.addEventListener('click', (event) => {
              event.stopPropagation();
              delete this.selections[stage.key];
              this.activeStageKey = stage.key;
              this.resetAddedState();
              this.render();
            });
          } else {
            const plus = document.createElement('span');
            plus.className = 'alpe-bundle__slot-plus';
            if (this.plusIconTemplate) plus.appendChild(this.plusIconTemplate.content.cloneNode(true));
            box.appendChild(plus);
          }

          const label = document.createElement('span');
          label.className = 'alpe-bundle__slot-label';
          label.textContent = selected ? this.getSelectionLabel(selected) : stage.title;

          if (selected) {
            const pricing = this.getBundlePricing(selected.variant);
            const price = document.createElement('span');
            price.className = 'alpe-bundle__slot-price';
            if (pricing.compareAt) {
              const compareAt = document.createElement('s');
              compareAt.textContent = this.formatMoney(pricing.compareAt);
              price.appendChild(compareAt);
            }
            const amount = document.createElement('span');
            amount.textContent = this.formatMoney(pricing.price);
            price.appendChild(amount);
            slot.appendChild(price);
          }

          slot.appendChild(box);
          if (remove) slot.appendChild(remove);
          slot.appendChild(label);
          this.summarySlotsNode.appendChild(slot);
        });
      }

      const selectedItems = this.getSelectedItems();
      const subtotal = selectedItems.reduce((sum, item) => sum + this.getBundlePricing(item.variant).regular, 0);
      const total = selectedItems.reduce((sum, item) => sum + this.getBundlePricing(item.variant).price, 0);
      const complete = this.isComplete();
      const incompleteCtaLabel = this.getIncompleteCtaLabel();
      const discount = Math.max(subtotal - total, 0);
      const subtotalNode = this.querySelector('[data-alpe-summary-subtotal]');
      const discountPercent = Math.max(0, Math.round(this.discountPercent || 0));

      if (this.summaryNode) this.summaryNode.classList.toggle('is-incomplete', !complete);
      this.renderSummaryState();
      this.updateSummaryVisibility();

      if (this.summaryProgressNode) {
        this.summaryProgressNode.textContent = `Sestavi svoj komplet (${selectedItems.length}/${this.stages.length})`;
      }

      this.setHtml('[data-alpe-summary-total]', this.formatMoney(total));
      if (subtotalNode) {
        subtotalNode.hidden = !(selectedItems.length > 0 && discount > 0);
        subtotalNode.innerHTML = this.formatMoney(subtotal);
      }
      if (this.summaryDiscountValueNode) {
        this.summaryDiscountValueNode.textContent = this.formatMoney(discount);
      }
      if (this.summaryDiscountPercentNode) {
        this.summaryDiscountPercentNode.textContent = String(discountPercent);
      }
      if (this.summaryDiscountPercentWrapNode) {
        this.summaryDiscountPercentWrapNode.hidden = !(complete && discountPercent > 0);
      }
      if (this.summaryBadgeNode) {
        this.summaryBadgeNode.hidden = !(complete && discountPercent > 0);
        if (complete && discountPercent > 0) {
          this.summaryBadgeNode.textContent = `-${discountPercent} %`;
          this.summaryBadgeNode.setAttribute('aria-label', `${discountPercent} % popusta`);
        }
      }

      this.submitButtons.forEach((button) => {
        const added = complete && this.addedToCart;
        button.disabled = this.loading || !this.configurationValid || added;
        button.classList.toggle('is-success', added);
        button.classList.toggle('is-incomplete', !complete);
        button.textContent = !this.configurationValid
          ? 'Nastavi 2–4 izdelke'
          : this.loading
          ? 'Dodajam...'
          : added
            ? this.addedLabel
            : this.submitError && complete
              ? 'Napaka — poskusi znova'
              : complete
                ? this.completeLabel
                : incompleteCtaLabel;
      });

      if (!complete && this.statusNode && this.statusNode.dataset.alpeStatusState === 'hint') {
        this.setStatus('');
      }
    }

    renderStageStatus() {
      if (!this.stageStatusNode) return;
      const current = this.stages.find((stage) => stage.key === this.activeStageKey);
      if (!current) {
        this.stageStatusNode.textContent = '';
        return;
      }
      this.stageStatusNode.textContent = this.selections[current.key]
        ? `${current.title} je izbran. Nadaljuj na naslednji korak ali zamenjaj izbiro.`
        : `Izberi izdelek za kategorijo: ${current.title}.`;
    }

    selectProduct(item) {
      const state = this.productState.get(item.blockId);
      const variant = state ? state.variant : this.getInitialVariant(item.product);
      if (!item.product.available) return;
      if (this.needsOptions(item.product) && !variant) {
        this.setCardStatus(item.blockId, 'Najprej izberi velikost.');
        return;
      }
      if (!variant || !variant.available) {
        this.setCardStatus(item.blockId, 'Ta izbira trenutno ni na voljo.');
        return;
      }

      this.resetAddedState();
      const wasComplete = this.isComplete();

      this.selections[item.stageKey] = this.createSelection(item, variant);
      const becameComplete = !wasComplete && this.isComplete();
      if (becameComplete) this.summaryCollapsed = false;

      const next = this.getNextIncompleteStage(item.stageKey);
      if (next) {
        this.activeStageKey = next.key;
      }
      this.setStatus('');
      this.render();
      if (this.isComplete()) this.syncCartState();
      if (next) this.scrollToStage(next.key);
    }

    async handleSubmit() {
      if (!this.isComplete()) {
        this.promptIncomplete();
        return;
      }
      await this.addToCart();
    }

    promptIncomplete() {
      const missing = this.getMissingStages();
      if (!missing.length) return;
      this.activeStageKey = missing[0].key;
      this.setStatus('');
      this.render();
      this.scrollToStage(missing[0].key);
    }

    async addToCart() {
      const selected = this.getSelectedItems();
      if (!selected.length || this.loading) return;

      this.loading = true;
      this.submitError = false;
      this.setStatus('');
      this.renderSummary();

      const bundleId = `alpe-${Date.now()}`;
      const requiredKeys = this.stages.map((stage) => stage.key).join(',');
      const payload = {
        items: selected.map((item) => ({
          id: item.variant.id,
          quantity: 1,
          properties: {
            '_alpe_bundle_id': bundleId,
            '_alpe_bundle_discount_code': this.discountCode || '',
            '_alpe_bundle_price_mode': this.useRegularPrices ? 'regular' : 'current',
            '_alpe_bundle_regular_price': String(this.getRegularPrice(item.variant)),
            '_alpe_bundle_current_price': String(Number(item.variant.price || 0)),
            '_alpe_bundle_discount_percent': String(this.discountPercent),
            '_alpe_bundle_required_count': String(this.stages.length),
            '_alpe_bundle_required_keys': requiredKeys,
            '_alpe_bundle_stage_key': item.stageKey,
            '_alpe_bundle_v3_id': bundleId,
            '_alpe_bundle_v3_discount_code': this.discountCode || '',
            '_alpe_bundle_v3_discount_percent': String(this.discountPercent),
            '_alpe_bundle_v3_required_count': String(this.stages.length),
            '_alpe_bundle_v3_required_keys': requiredKeys,
            '_alpe_bundle_v3_stage_key': item.stageKey,
            'Komplet': this.bundleName,
            'Kategorija': this.getStageTitle(item.stageKey)
          }
        }))
      };

      try {
        const response = await fetch(`${this.root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok) throw data;

        const discountActivated = await this.applyDiscountCode();
        if (!discountActivated) throw new Error('Bundle discount could not be activated.');

        let cart = await this.fetchCart();
        if (cart && !this.bundleHasDiscountAllocations(cart, bundleId)) {
          await new Promise((resolve) => window.setTimeout(resolve, 150));
          cart = await this.fetchCart();
        }
        if (!cart || !this.bundleHasDiscountAllocations(cart, bundleId)) {
          throw new Error('Bundle discount was not allocated.');
        }
        const cartForUi = cart || { item_count: selected.length };
        this.updateCartCount(cartForUi);
        this.lastAddedBundleId = bundleId;
        this.addedToCart = cart ? this.cartContainsSelectedBundle(cart, bundleId) : true;
        this.highlightCartButton(cartForUi);
        document.dispatchEvent(new CustomEvent('alpe:bundle:add', { detail: { response: data, cart, bundleId } }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { response: data, cart } }));
        if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));

        this.goToCart();
        return;
      } catch (error) {
        await this.removeBundleFromCart(bundleId);
        this.submitError = true;
        this.setStatus('Popusta ni bilo mogoče varno obračunati. Komplet ni bil dodan; poskusi znova.');
      } finally {
        this.loading = false;
        this.renderSummary();
      }
    }

    async applyDiscountCode() {
      const code = this.discountCode.trim();
      if (!code) return false;
      try {
        const response = await fetch(`${this.root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ discount: code })
        });
        const cart = await response.json();
        if (!response.ok) return false;
        const normalizedCode = code.toLowerCase();
        const discountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        return discountCodes.some((discount) => String(discount.code || '').toLowerCase() === normalizedCode
          && discount.applicable === true);
      } catch (error) {
        return false;
      }
    }

    bundleHasDiscountAllocations(cart, bundleId) {
      const lines = cart && Array.isArray(cart.items) ? cart.items : [];
      const bundleLines = lines.filter((line) => {
        const properties = line.properties || {};
        return properties._alpe_bundle_v3_id === bundleId;
      });
      if (bundleLines.length !== this.stages.length) return false;
      const expectedCode = this.discountCode.trim().toLowerCase();
      const expectedPercent = Number(this.discountPercent || 0);
      return bundleLines.every((line) => {
        const allocations = Array.isArray(line.line_level_discount_allocations)
          ? line.line_level_discount_allocations
          : [];
        const hasExpectedAllocation = allocations.some((allocation) => {
          const application = allocation.discount_application || {};
          const title = String(application.title || '').trim().toLowerCase();
          const value = Number(application.value || 0);
          const percentageMatches = application.value_type !== 'percentage'
            || Math.abs(value - expectedPercent) < 0.01;
          return Number(allocation.amount || 0) > 0
            && application.type === 'discount_code'
            && title === expectedCode
            && percentageMatches;
        });
        if (hasExpectedAllocation) return true;

        const discounts = Array.isArray(line.discounts) ? line.discounts : [];
        return discounts.some((discount) => Number(discount.amount || 0) > 0
          && String(discount.title || '').trim().toLowerCase() === expectedCode);
      });
    }

    async removeBundleFromCart(bundleId) {
      if (!bundleId) return;
      const cart = await this.fetchCart();
      if (!cart || !Array.isArray(cart.items)) return;
      const updates = {};
      cart.items.forEach((line) => {
        const properties = line.properties || {};
        if (properties._alpe_bundle_v3_id === bundleId && line.key) updates[line.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      try {
        const response = await fetch(`${this.root}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error('Bundle rollback failed.');
      } catch (error) {
        return;
      }
    }

    goToCart() {
      window.location.href = `${this.root}cart`;
    }

    async fetchCart() {
      try {
        const response = await fetch(`${this.root}cart.js`, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
        });
        if (!response.ok) return null;
        return await response.json();
      } catch (error) {
        return null;
      }
    }

    async syncCartState(cartOverride) {
      const syncToken = ++this.cartSyncToken;
      const cart = cartOverride || await this.fetchCart();
      if (syncToken !== this.cartSyncToken || !cart) return;

      this.updateCartCount(cart);

      if (!this.isComplete()) {
        this.resetAddedState();
        this.renderSummary();
        return;
      }

      const matchingBundleId = this.findMatchingBundleId(cart);
      this.addedToCart = Boolean(matchingBundleId);
      this.lastAddedBundleId = matchingBundleId || '';
      this.renderSummary();
    }

    findMatchingBundleId(cart) {
      const items = cart && Array.isArray(cart.items) ? cart.items : [];
      const groups = new Map();

      items.forEach((line) => {
        const properties = line.properties || {};
        const bundleId = properties._alpe_bundle_id;
        if (!bundleId || Number(line.quantity || 0) < 1) return;
        if (properties.Komplet !== this.bundleName) return;
        if (Number(properties._alpe_bundle_discount_percent || 0) !== Number(this.discountPercent || 0)) return;
        if (!groups.has(bundleId)) groups.set(bundleId, []);
        groups.get(bundleId).push(line);
      });

      for (const [bundleId, lines] of groups) {
        const groupedCart = { items: lines };
        if (this.cartContainsSelectedBundle(groupedCart, bundleId)
          && this.bundleHasDiscountAllocations(groupedCart, bundleId)) return bundleId;
      }
      return '';
    }

    cartContainsSelectedBundle(cart, bundleId) {
      const lines = cart && Array.isArray(cart.items) ? cart.items : [];
      return this.getSelectedItems().every((selected) => lines.some((line) => {
        const properties = line.properties || {};
        return properties._alpe_bundle_id === bundleId
          && properties.Komplet === this.bundleName
          && properties.Kategorija === this.getStageTitle(selected.stageKey)
          && Number(properties._alpe_bundle_discount_percent || 0) === Number(this.discountPercent || 0)
          && String(line.variant_id || line.id) === String(selected.variant.id)
          && Number(line.quantity || 0) > 0;
      }));
    }

    restoreSelections() {
      let saved;
      try {
        saved = JSON.parse(window.sessionStorage.getItem(this.storageKey) || 'null');
      } catch (error) {
        return;
      }
      if (!saved || !Array.isArray(saved.items)) return;

      saved.items.forEach((savedItem) => {
        const item = this.products.find((candidate) => candidate.stageKey === savedItem.stageKey
          && (candidate.blockId === savedItem.blockId || String(candidate.product.id) === String(savedItem.productId)));
        if (!item) return;
        const variant = (item.product.variants || []).find((candidate) => String(candidate.id) === String(savedItem.variantId));
        if (!variant || !variant.available) return;

        this.selections[item.stageKey] = this.createSelection(item, variant);
        const state = this.productState.get(item.blockId);
        if (state) {
          state.variant = variant;
          state.selectedOptions = {};
          this.getVisibleOptions(item.product).forEach((option) => {
            state.selectedOptions[option.index] = variant.options[option.index];
          });
          const card = this.cardNodes.get(item.blockId);
          if (card) this.renderOptions(item, card);
        }
      });

      if (saved.activeStageKey && this.stages.some((stage) => stage.key === saved.activeStageKey)) {
        this.activeStageKey = saved.activeStageKey;
      }
    }

    persistSelections() {
      const selected = this.getSelectedItems();
      try {
        if (!selected.length) {
          window.sessionStorage.removeItem(this.storageKey);
          return;
        }
        window.sessionStorage.setItem(this.storageKey, JSON.stringify({
          activeStageKey: this.activeStageKey,
          items: selected.map((item) => ({
            stageKey: item.stageKey,
            blockId: item.blockId,
            productId: item.productId,
            variantId: item.variant.id
          }))
        }));
      } catch (error) {
        return;
      }
    }

    resetAddedState() {
      this.submitError = false;
      if (!this.addedToCart && !this.lastAddedBundleId) return;
      this.addedToCart = false;
      this.lastAddedBundleId = '';
    }

    createSelection(item, variant) {
      return {
        blockId: item.blockId,
        stageKey: item.stageKey,
        productId: item.product.id,
        variant,
        title: item.displayTitle || item.product.title,
        variantTitle: this.getVariantLabel(item.product, variant),
        image: variant.featuredImage || item.product.featuredImage,
        productUrl: item.product.url
      };
    }

    getVisibleOptions(product) {
      return (product.options || [])
        .map((option, index) => ({ ...option, index }))
        .filter((option) => option.name && option.name !== 'Title' && option.values.some((value) => value !== 'Default Title'));
    }

    needsOptions(product) {
      return this.getVisibleOptions(product).length > 0;
    }

    getInitialVariant(product) {
      const variants = product.variants || [];
      const available = variants.find((variant) => variant.available);
      return available || null;
    }

    findSelectedVariant(item, state) {
      const visibleOptions = this.getVisibleOptions(item.product);
      if (visibleOptions.some((option) => !state.selectedOptions[option.index])) return null;
      return (item.product.variants || []).find((variant) => {
        if (!variant.available) return false;
        return visibleOptions.every((option) => variant.options[option.index] === state.selectedOptions[option.index]);
      }) || null;
    }

    isOptionValueAvailable(item, optionIndex, value, state) {
      const selected = { ...(state ? state.selectedOptions : {}), [optionIndex]: value };
      return (item.product.variants || []).some((variant) => {
        if (!variant.available) return false;
        return Object.entries(selected).every(([index, selectedValue]) => variant.options[Number(index)] === selectedValue);
      });
    }

    getSelectedItems() {
      return this.stages
        .map((stage) => this.selections[stage.key])
        .filter(Boolean);
    }

    getMissingStages() {
      return this.stages.filter((stage) => !this.selections[stage.key]);
    }

    getIncompleteCtaLabel() {
      const stage = this.getMissingStages()[0];
      if (!stage) return this.completeLabel;
      const configuredLabel = String(stage.incompleteCtaLabel || '').trim();
      if (configuredLabel) return configuredLabel;
      const title = String(stage.title || '').trim();
      return title ? `Dodaj ${title.toLocaleLowerCase('sl-SI')}` : this.incompleteLabel;
    }

    isComplete() {
      return this.configurationValid && this.getMissingStages().length === 0;
    }

    getNextIncompleteStage(currentKey) {
      const currentIndex = this.stages.findIndex((stage) => stage.key === currentKey);
      const afterCurrent = this.stages.slice(currentIndex + 1).find((stage) => !this.selections[stage.key]);
      if (afterCurrent) return afterCurrent;
      return this.stages.find((stage) => !this.selections[stage.key]) || null;
    }

    getStageTitle(stageKey) {
      const stage = this.stages.find((item) => item.key === stageKey);
      return stage ? stage.title : stageKey;
    }

    getVariantLabel(product, variant) {
      if (!variant || !variant.title || variant.title === 'Default Title') return '';
      if (!this.needsOptions(product)) return '';
      return variant.title;
    }

    getSelectionLabel(selection) {
      return selection.variantTitle ? `${selection.title} · ${selection.variantTitle}` : selection.title;
    }

    setCardStatus(blockId, text) {
      const card = this.cardNodes.get(blockId);
      const status = card ? card.querySelector('[data-alpe-card-status]') : null;
      if (status) status.textContent = text;
    }

    setStatus(text, state) {
      if (!this.statusNode) return;
      const nextState = state || (text ? 'message' : 'empty');
      this.statusNode.textContent = text;
      this.statusNode.dataset.alpeStatusState = nextState;
    }

    setText(selector, text) {
      this.querySelectorAll(selector).forEach((node) => {
        node.textContent = text;
      });
    }

    setHtml(selector, html) {
      this.querySelectorAll(selector).forEach((node) => {
        node.innerHTML = html;
      });
    }

    scrollToStage(stageKey) {
      if (this.scrollAnimationFrame) window.cancelAnimationFrame(this.scrollAnimationFrame);

      this.scrollAnimationFrame = window.requestAnimationFrame(() => {
        const target = Array.from(this.querySelectorAll('[data-alpe-stage-section]'))
          .find((section) => section.dataset.stageKey === stageKey);
        if (!target) return;

        const offset = window.matchMedia('(max-width: 760px)').matches ? 92 : 128;
        const start = window.scrollY;
        const destination = Math.max(0, target.getBoundingClientRect().top + start - offset);
        const distance = destination - start;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (reduceMotion || Math.abs(distance) < 2) {
          window.scrollTo(0, destination);
          this.scrollAnimationFrame = null;
          return;
        }

        const duration = 750;
        const startedAt = performance.now();
        const easeInOutCubic = (progress) => progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;

        const animate = (now) => {
          const progress = Math.min((now - startedAt) / duration, 1);
          window.scrollTo(0, start + distance * easeInOutCubic(progress));
          if (progress < 1) {
            this.scrollAnimationFrame = window.requestAnimationFrame(animate);
          } else {
            this.scrollAnimationFrame = null;
          }
        };

        this.scrollAnimationFrame = window.requestAnimationFrame(animate);
      });
    }

    updateCartCount(cart) {
      if (!cart) return;
      const hasItems = cart.item_count > 0;
      document.body.classList.toggle('cart-has-items', hasItems);
      document.documentElement.classList.toggle('cart-has-items', hasItems);
      document.querySelectorAll('.cart-link__bubble').forEach((bubble) => {
        bubble.classList.toggle('cart-link__bubble--visible', hasItems);
      });
      document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
      });
    }

    highlightCartButton(cart) {
      if (!cart || cart.item_count <= 0) return;
      const targets = document.querySelectorAll('.site-nav__thumb-cart, .site-nav__link--cart');
      targets.forEach((target) => {
        target.classList.remove('alpe-cart-confirmed');
        void target.offsetWidth;
        target.classList.add('alpe-cart-confirmed');
      });
      window.setTimeout(() => {
        targets.forEach((target) => target.classList.remove('alpe-cart-confirmed'));
      }, 1200);
    }

    formatMoney(cents) {
      return `${(Number(cents || 0) / 100).toFixed(2)} €`;
    }

    getRegularPrice(priceSource) {
      const currentPrice = Number(priceSource && priceSource.price || 0);
      return currentPrice;
    }

    getPricing(priceSource) {
      const currentPrice = Number(priceSource && priceSource.price || 0);
      const compareAtPrice = Number(priceSource && priceSource.compareAtPrice || 0);

      if (this.useRegularPrices) {
        return {
          price: this.getRegularPrice(priceSource),
          compareAt: 0
        };
      }

      return {
        price: currentPrice,
        compareAt: compareAtPrice > currentPrice ? compareAtPrice : 0
      };
    }

    getBundlePricing(priceSource) {
      const regular = this.getRegularPrice(priceSource);
      const discountPercent = Math.min(100, Math.max(0, Number(this.discountPercent || 0)));
      const discount = Math.round(regular * discountPercent / 100);
      const price = Math.max(regular - discount, 0);

      return {
        regular,
        price,
        compareAt: discount > 0 ? regular : 0
      };
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
